
// // client/src/components/events/EventDetail.jsx
// import React, { useEffect, useMemo, useState } from "react";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import AppFooter from "../AppFooter";
// import { FaEnvelope, FaPlus, FaSave, FaShare, FaTimes, FaTasks, FaTrash, FaArrowLeft } from "react-icons/fa";
// import CommentsPanel from "../comments/CommentsPanel";
// import PostChoiceModal from "../media/PostChoiceModal";
// import { useMessagesUI } from "../../context/MessagesContext";
// import { useWebShare } from "../../hooks/useWebShare";
// import MediaTile from "../media/MediaTile";
// import { sessionRequestConfig, getSessionLocal, canEditFromSession, isEditRoleName } from "../../services/sessionLocal";
// import CollaboratorsPanel from "../event/CollaboratorsPanel";
// import InviteCollaboratorModal from "../event/InviteCollaboratorModal";
// import TimeSelect from "../TimeSelect";
// import { localToUTC } from "../../utils/timezoneUtils";
// import ConfirmDeleteModal from "../../modals/ConfirmDeleteModal";

// /* ---------- small helper for multi-try requests ---------- */
// const fetchFirst = async (attempts) => {
//   let lastErr;
//   for (const attempt of attempts) {
//     try { return await attempt(); } catch (e) { lastErr = e; }
//   }
//   throw lastErr || new Error("All requests failed");
// };

// /* ---------- helpers ---------- */
// const toAbs = (baseUrl, p) =>
//   !p ? p : /^https?:\/\//i.test(p) ? p : `${baseUrl}${p.startsWith('/') ? '' : '/'}${p}`;
// const isImage = (f) =>
//   (f?.mimetype?.startsWith?.("image/")) || /\.(png|jpe?g|gif|webp|svg|bmp)$/i.test(f?.path || f || "");
// const isVideo = (f) =>
//   (f?.mimetype?.startsWith?.("video/")) || /\.(mp4|mov|webm|ogg|avi|mkv)$/i.test(f?.path || f || "");

// const videoFixProps = {
//   playsInline: true,
//   preload: "metadata",
//   crossOrigin: "anonymous",
//   onLoadedMetadata: (e) => {
//     try {
//       // iOS/Safari first-frame fix to avoid black poster
//       if (e.currentTarget.currentTime === 0) e.currentTarget.currentTime = 0.1;
//     } catch {}
//   },
// };

// const EventDetail = () => {
//   const [event, setEvent] = useState(null);
//   const [registerStatus, setRegisterStatus] = useState("");

//   // Event fields matching EventAdd
//   const [name, setName] = useState('');
//   const [description, setDescription] = useState('');
//   const [type, setType] = useState('');
//   const [startDate, setStartDate] = useState('');
//   const [startTime, setStartTime] = useState('09:00');
//   const [endDate, setEndDate] = useState('');
//   const [endTime, setEndTime] = useState('17:00');
//   const [tenantTimezone, setTenantTimezone] = useState('America/Chicago');

//   // event-level media
//   const [eventImages, setEventImages] = useState([]);
//   const [eventVideos, setEventVideos] = useState([]);

//   // item list + item-level media
//   const [eventItems, setEventItems] = useState([]);
//   const [eventItemImages, setEventItemImages] = useState({});
//   const [eventItemVideos, setEventItemVideos] = useState({});

//   // used by UI and post flow
//   const [images, setImages] = useState([]);
//   const [videos, setVideos] = useState([]);

//   const [loading, setLoading] = useState(true);
//   const [messages, setMessages] = useState([]);
//   const [newMessage, setNewMessage] = useState("");
//   const [postChoiceOpen, setPostChoiceOpen] = useState(false);

//   const [collabRole, setCollabRole] = useState(null);
//   const me = getSessionLocal();
//   const userCanEdit = useMemo(() => {
//     const iOwnThisEvent = Number(event?.tenantid) === Number(me.tenantId);
//     const collabEdit = isEditRoleName(collabRole) || collabRole === "editor";
//     return iOwnThisEvent || collabEdit || canEditFromSession();
//   }, [collabRole, event?.tenantid, me.tenantId]);

//   const [inviteOpen, setInviteOpen] = useState(false);

//   const navigate = useNavigate();
//   const { tenant, eventId } = useParams();
//   const baseUrl =
//     process.env.REACT_APP_BASE_URL ||
//     (typeof window !== "undefined" ? window.location.origin : "http://localhost:5000");
//   const { openMessages } = useMessagesUI();
//   const { share } = useWebShare();
  
//   // Media selection state - stores selected media URLs
//   const [selectedMedia, setSelectedMedia] = useState({}); // { [url]: true }
  
//   // Toggle selection for a single media item
//   const toggleSelect = (url) => setSelectedMedia((prev) => ({ ...prev, [url]: !prev[url] }));
  
//   // Delete confirmation modal state
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
  
//   const cfg = sessionRequestConfig();

//   /* ---- load my role (with session headers) ---- */
//   useEffect(() => {
//     let alive = true;
//     const cfg = sessionRequestConfig();
//     axios.get(`/api/collab/events/${eventId}/my-role`, cfg)
//       .then(({ data }) => { if (alive) setCollabRole(data?.role || null); })
//       .catch(() => { if (alive) setCollabRole(null); });
//     return () => { alive = false; };
//   }, [eventId]);

//   /* ---- Fetch tenant timezone ---- */
//   useEffect(() => {
//     const fetchTenantTimezone = async () => {
//       try {
//         const response = await axios.get(
//           `${baseUrl}/api/tenants/${tenant}/timezone`,
//           { withCredentials: true }
//         );
//         if (response.data.timezone) {
//           setTenantTimezone(response.data.timezone);
//         }
//       } catch (err) {
//         console.error('Failed to fetch tenant timezone:', err);
//         const browserTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
//         setTenantTimezone(browserTZ);
//       }
//     };
    
//     fetchTenantTimezone();
//   }, [tenant, baseUrl]);

//   /* ---- load event + media + items ---- */
//   useEffect(() => {
//     document.body.classList.add("eventlist-fullbleed");
//     return () => document.body.classList.remove("eventlist-fullbleed");
//   }, []);

//   useEffect(() => {
//     let alive = true;
//     (async () => {
//       try {
//         setLoading(true);

//         // event
//         const { data: eData } = await fetchFirst([
//           () => axios.get(`/api/events/${tenant}/events/${eventId}`, cfg),
//           () => axios.get(`/api/events/${tenant}/${eventId}`, cfg),
//           () => axios.get(`/api/${tenant}/events/${eventId}`, cfg),
//         ]);
//         if (!alive) return;
//         const e = eData?.event || eData || {};
//         setEvent(e);

//         // Populate form fields from loaded event
//         setName(e.name || '');
//         setDescription(e.description || '');
//         setType(e.type || '');
        
//         // Parse dates and times
//         if (e.startdate) {
//           const startDT = new Date(e.startdate);
//           setStartDate(startDT.toISOString().split('T')[0]);
//           setStartTime(startDT.toTimeString().slice(0, 5)); // HH:MM
//         }
//         if (e.enddate) {
//           const endDT = new Date(e.enddate);
//           setEndDate(endDT.toISOString().split('T')[0]);
//           setEndTime(endDT.toTimeString().slice(0, 5)); // HH:MM
//         }

//         // event images
//         const { data: imgData } = await fetchFirst([
//           () => axios.get(`/api/events/${tenant}/events/${eventId}/images`, cfg),
//           () => axios.get(`/api/events/${tenant}/${eventId}/images`, cfg),
//           () => axios.get(`/api/${tenant}/${eventId}/images`, cfg),
//         ]);
//         if (!alive) return;
//         setEventImages(imgData?.images || []);

//         // items
//         const { data: itemsData } = await fetchFirst([
//           () => axios.get(`/api/events/${tenant}/events/${eventId}/items`, cfg),
//           () => axios.get(`/api/events/${tenant}/${eventId}/items`, cfg),
//           () => axios.get(`/api/${tenant}/${eventId}/items`, cfg),
//         ]);
//         if (!alive) return;
//         const items = itemsData?.items || [];
//         setEventItems(items);

//         const itemImagesMap = {};
//         const itemVideosMap = {};
//         await Promise.all(
//           items.map(async (it) => {
//             // images
//             try {
//               const { data } = await fetchFirst([
//                 () => axios.get(`/api/events/${tenant}/events/${eventId}/items/${it.id}/images`, cfg),
//                 () => axios.get(`/api/events/${tenant}/${eventId}/items/${it.id}/images`, cfg),
//                 () => axios.get(`/api/${tenant}/${eventId}/items/${it.id}/images`, cfg),
//               ]);
//               itemImagesMap[it.id] = data?.images || [];
//             } catch { itemImagesMap[it.id] = []; }
      
//             // videos
//             try {
//               const { data } = await fetchFirst([
//                 () => axios.get(`/api/${tenant}/events/${eventId}/items/${it.id}/videos`, cfg),
//                 () => axios.get(`/api/events/${tenant}/events/${eventId}/items/${it.id}/videos`, cfg),
//                 () => axios.get(`/api/events/${tenant}/${eventId}/items/${it.id}/videos`, cfg),
//               ]);
//               itemVideosMap[it.id] = data?.videos || [];
//             } catch { itemVideosMap[it.id] = []; }
//           })
//         );
//         if (!alive) return;
//         setEventItemImages(itemImagesMap);
//         setEventItemVideos(itemVideosMap);
//       } catch (err) {
//         console.error("Error loading event data:", err);
//       } finally {
//         if (alive) setLoading(false);
//       }
//     })();
//     return () => { alive = false; };
//   }, [tenant, eventId]);

//   /* ---- load messages ---- */
//   useEffect(() => {
//     axios
//       .get(`${baseUrl}/api/events/${tenant}/events/${eventId}/messages`)
//       .then((res) => setMessages(Array.isArray(res.data) ? res.data : res.data?.messages || res.data || []))
//       .catch(() => setMessages([]));
//   }, [tenant, eventId, baseUrl]);

//   /* ---- helpers ---- */
//   const handleShare = async () => {
//     const eventUrl = `${window.location.origin}/${tenant}/${eventId}`;
//     try {
//       await share({ url: eventUrl, title: event?.name || "Event" });
//     } catch (err) {
//       console.error("Share error:", err);
//       navigator.clipboard?.writeText?.(eventUrl).then(() => {
//         alert("Event link copied to clipboard!");
//       });
//     }
//   };

//   const sendMessage = async () => {
//     if (!newMessage.trim()) return;
//     try {
//       const response = await axios.post(`${baseUrl}/api/events/${tenant}/events/${eventId}/messages`, {
//         message: newMessage,
//       });
//       if (response.data.success) {
//         setMessages([...messages, { message: newMessage }]);
//         setNewMessage("");
//       }
//     } catch (err) {
//       console.error("Error sending message:", err);
//     }
//   };

//   const updateEvent = async (e) => {
//     e?.preventDefault?.();
//     if (!name || !description) {
//       setRegisterStatus("Name and Description are required.");
//       return;
//     }
//     try {
//       // Convert to UTC before sending
//       const startDateTimeUTC = localToUTC(startDate, startTime, tenantTimezone);
//       const endDateTimeUTC = localToUTC(endDate, endTime, tenantTimezone);

//       const response = await axios.put(
//         `${baseUrl}/api/events/${tenant}/events/${eventId}`,
//         {
//           name,
//           description,
//           type,
//           startdate: startDateTimeUTC,
//           enddate: endDateTimeUTC,
//           timezone: tenantTimezone,
//         }
//       );
//       if (response.data.success) {
//         setRegisterStatus("Event updated successfully!");
//       } else {
//         setRegisterStatus("Failed to update event.");
//       }
//     } catch (error) {
//       console.error("Error updating event:", error);
//       setRegisterStatus("Error updating event.");
//     }
//   };

//   const handleCancel = () => navigate(`/${tenant}/event`);
//   const handleItem = () => navigate(`/${tenant}/${eventId}/eventItemAdd`);
//   // const handleTask = () => navigate(`/${tenant}/${eventId}/taskAdd`);
//   const handleTask = () => navigate(`/${tenant}/${eventId}/task`);

//   /**
//    * Handle posting selected media
//    */
//   const handlePostSelected = () => {
//     const selectedUrls = Object.keys(selectedMedia).filter((url) => selectedMedia[url]);
    
//     if (selectedUrls.length === 0) {
//       alert("Please select at least one media item to post.");
//       return;
//     }

//     const toPublic = (p) => (p?.startsWith("/public/") ? p : p?.startsWith("/tenants/") ? `/public${p}` : p);

//     const selectedImages = [];
//     const selectedVideos = [];

//     // Check event-level media
//     eventImages.forEach((img) => {
//       const url = toAbs(baseUrl, img.path || img.url || img);
//       if (selectedUrls.includes(url)) {
//         selectedImages.push(toPublic(img.path || img.url || img));
//       }
//     });

//     eventVideos.forEach((vid) => {
//       const url = toAbs(baseUrl, vid.path || vid.url || vid);
//       if (selectedUrls.includes(url)) {
//         selectedVideos.push(toPublic(vid.path || vid.url || vid));
//       }
//     });

//     // Check item-level media
//     Object.keys(eventItemImages).forEach((itemId) => {
//       eventItemImages[itemId].forEach((img) => {
//         const url = toAbs(baseUrl, img.path || img.url || img);
//         if (selectedUrls.includes(url)) {
//           selectedImages.push(toPublic(img.path || img.url || img));
//         }
//       });
//     });

//     Object.keys(eventItemVideos).forEach((itemId) => {
//       eventItemVideos[itemId].forEach((vid) => {
//         const url = toAbs(baseUrl, vid.path || vid.url || vid);
//         if (selectedUrls.includes(url)) {
//           selectedVideos.push(toPublic(vid.path || vid.url || vid));
//         }
//       });
//     });

//     const cover = selectedImages[0] || "";

//     navigate(`/${tenant}/${eventId}/mediaPost`, {
//       state: {
//         context: "event",
//         tenant,
//         eventId,
//         title: name || "",
//         description: description || "",
//         image: cover,
//         images: selectedImages,
//         videos: selectedVideos,
//         event,
//       },
//       replace: false,
//     });
//   };

//   /**
//    * Handle deleting selected media - Shows confirmation modal
//    */
//   const handleDeleteSelected = () => {
//     const selectedUrls = Object.keys(selectedMedia).filter((url) => selectedMedia[url]);
    
//     if (selectedUrls.length === 0) {
//       alert("Please select at least one media item to delete.");
//       return;
//     }

//     // Show confirmation modal instead of window.confirm
//     setShowDeleteModal(true);
//   };

//   /**
//    * Perform the actual deletion after confirmation
//    */
//   const performDelete = async () => {
//     const selectedUrls = Object.keys(selectedMedia).filter((url) => selectedMedia[url]);

//     try{
//       const eventMediaUrls = [];
//       const itemMediaUrls = {};

//       // Check event-level media
//       eventImages.forEach((img) => {
//         const url = toAbs(baseUrl, img.path || img.url || img);
//         if (selectedUrls.includes(url)) {
//           eventMediaUrls.push(url);
//         }
//       });

//       eventVideos.forEach((vid) => {
//         const url = toAbs(baseUrl, vid.path || vid.url || vid);
//         if (selectedUrls.includes(url)) {
//           eventMediaUrls.push(url);
//         }
//       });

//       // Check item-level media
//       Object.keys(eventItemImages).forEach((itemId) => {
//         eventItemImages[itemId].forEach((img) => {
//           const url = toAbs(baseUrl, img.path || img.url || img);
//           if (selectedUrls.includes(url)) {
//             if (!itemMediaUrls[itemId]) itemMediaUrls[itemId] = [];
//             itemMediaUrls[itemId].push(url);
//           }
//         });
//       });

//       Object.keys(eventItemVideos).forEach((itemId) => {
//         eventItemVideos[itemId].forEach((vid) => {
//           const url = toAbs(baseUrl, vid.path || vid.url || vid);
//           if (selectedUrls.includes(url)) {
//             if (!itemMediaUrls[itemId]) itemMediaUrls[itemId] = [];
//             itemMediaUrls[itemId].push(url);
//           }
//         });
//       });

//       // Call backend API for event-level media
//       if (eventMediaUrls.length > 0) {
//         const response = await axios.delete(
//           `${baseUrl}/api/events/${tenant}/events/${eventId}/media`,
//           { data: { urls: eventMediaUrls } }
//         );
        
//         if (!response.data.success) {
//           throw new Error(response.data.message || 'Failed to delete event media');
//         }
//       }

//       // Call backend API for item-level media
//       for (const itemId of Object.keys(itemMediaUrls)) {
//         const response = await axios.delete(
//           `${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}/media`,
//           { data: { urls: itemMediaUrls[itemId] } }
//         );
        
//         if (!response.data.success) {
//           throw new Error(response.data.message || `Failed to delete media for item ${itemId}`);
//         }
//       }

//       // Update UI state after successful deletion
//       setEventImages((prev) => 
//         (prev || []).filter((x) => !selectedUrls.includes(toAbs(baseUrl, x.path || x.url || x)))
//       );
//       setEventVideos((prev) => 
//         (prev || []).filter((x) => !selectedUrls.includes(toAbs(baseUrl, x.path || x.url || x)))
//       );

//       setEventItemImages((prev) => {
//         const next = { ...prev };
//         Object.keys(next).forEach((itemId) => {
//           next[itemId] = (next[itemId] || []).filter(
//             (x) => !selectedUrls.includes(toAbs(baseUrl, x.path || x.url || x))
//           );
//         });
//         return next;
//       });

//       setEventItemVideos((prev) => {
//         const next = { ...prev };
//         Object.keys(next).forEach((itemId) => {
//           next[itemId] = (next[itemId] || []).filter(
//             (x) => !selectedUrls.includes(toAbs(baseUrl, x.path || x.url || x))
//           );
//         });
//         return next;
//       });

//       // Clear selection
//       setSelectedMedia({});

//     } catch (error) {
//       console.error("Error deleting selected media:", error);
//       alert(`Failed to delete media: ${error.message || 'Unknown error'}. Please try again.`);
//     }
//   };

//   /**
//    * Handle deleting a single event-level media item
//    */
//   const handleDelete = async (url) => {
//     if (!window.confirm("Delete this media?")) return;
    
//     try {
//       const response = await axios.delete(
//         `${baseUrl}/api/events/${tenant}/events/${eventId}/media/single`,
//         { data: { url } }
//       );

//       if (!response.data.success) {
//         throw new Error(response.data.message || 'Failed to delete media');
//       }

//       setEventImages((prev) => (prev || []).filter((x) => toAbs(baseUrl, x.path || x.url || x) !== url));
//       setEventVideos((prev) => (prev || []).filter((x) => toAbs(baseUrl, x.path || x.url || x) !== url));
//       setSelectedMedia((prev) => { const n = { ...prev }; delete n[url]; return n; });

//     } catch (error) {
//       console.error("Error deleting media:", error);
//       alert(`Failed to delete media: ${error.message || 'Unknown error'}. Please try again.`);
//     }
//   };

//   /**
//    * Handle deleting a single item-level media item
//    */
//   const handleDeleteItemMedia = async (itemId, url) => {
//     if (!window.confirm("Delete this item media?")) return;
    
//     try {
//       const response = await axios.delete(
//         `${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}/media/single`,
//         { data: { url } }
//       );

//       if (!response.data.success) {
//         throw new Error(response.data.message || 'Failed to delete item media');
//       }

//       setEventItemImages((prev) => {
//         const next = { ...prev };
//         next[itemId] = (next[itemId] || []).filter((x) => toAbs(baseUrl, x.path || x.url || x) !== url);
//         return next;
//       });
//       setEventItemVideos((prev) => {
//         const next = { ...prev };
//         next[itemId] = (next[itemId] || []).filter((x) => toAbs(baseUrl, x.path || x.url || x) !== url);
//         return next;
//       });
//       setSelectedMedia((prev) => { const n = { ...prev }; delete n[url]; return n; });

//     } catch (error) {
//       console.error("Error deleting item media:", error);
//       alert(`Failed to delete item media: ${error.message || 'Unknown error'}. Please try again.`);
//     }
//   };

//   if (loading) return <p>Loading event details...</p>;

//   /* ---- merged gallery for the event ---- */
//   const imgSrcs = (eventImages?.length ? eventImages : (event?.files || []))
//     .filter((f) => isImage?.(f) ?? /\.(png|jpe?g|gif|webp|svg)$/i.test(f?.path || f || ""))
//     .map((i) => ({ url: toAbs(baseUrl, i.path || i.url || i), isVideo: false }));
//   const vidSrcs = (eventVideos?.length ? eventVideos : (event?.files || []))
//     .filter((f) => isVideo?.(f) ?? /\.(mp4|mov|webm|ogg)$/i.test(f?.path || f || ""))
//     .map((v) => ({ url: toAbs(baseUrl, v.path || v.url || v), isVideo: true }));
//   const eventMedia = [...imgSrcs, ...vidSrcs];

//   // Count selected media
//   const selectedCount = Object.values(selectedMedia).filter(Boolean).length;

//   return (
//     <div className="container">
//       <h2 className="hdr hdr--primary hdr--lg">Event Details</h2>

//       {/* Collaboration header */}
//       <div className="flex items-center gap-2" style={{ padding: "0 12px 8px" }}>
//         <span className="text-sm text-neutral-600 dark:text-neutral-300">Collaboration</span>
//         {userCanEdit && (
//           <button
//             type="button"
//             className="btn btn-sm btn-outline"
//             onClick={() => setInviteOpen(true)}
//             title="Invite collaborators"
//           >
//             <FaPlus className="inline mr-1" />
//             Invite
//           </button>
//         )}
//       </div>

//       {/* CollaboratorsPanel */}
//       <CollaboratorsPanel
//         tenantIdForRoutes={tenant}
//         eventId={eventId}
//         currentUserId={me.userId}
//         canManage={userCanEdit}
//       />

//       {!loading ? (
//         <>
//           {/* Selected media count indicator */}
//           {selectedCount > 0 && (
//             <div
//               style={{
//                 padding: "8px 12px",
//                 margin: "8px 12px",
//                 background: "#ff6800",
//                 color: "white",
//                 borderRadius: "8px",
//                 fontSize: "14px",
//                 fontWeight: "600",
//               }}
//             >
//               {selectedCount} media item{selectedCount !== 1 ? "s" : ""} selected
//             </div>
//           )}

//           {/* Event form fields - matching EventAdd styling */}
//           <form onSubmit={updateEvent}>
//             <div className="form-group">
//               <label htmlFor="name">Event Name</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 id="name"
//                 name="name"
//                 value={name}
//                 onChange={(e) => setName(e.target.value)}
//                 placeholder="Enter event name"
//                 disabled={!userCanEdit}
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label htmlFor="description">Event Description</label>
//               <textarea
//                 className="form-control"
//                 id="description"
//                 name="description"
//                 value={description}
//                 onChange={(e) => setDescription(e.target.value)}
//                 placeholder="Enter event description"
//                 rows={4}
//                 disabled={!userCanEdit}
//               />
//             </div>

//             <div className="form-group">
//               <label htmlFor="type">Event Type</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 id="type"
//                 name="type"
//                 value={type}
//                 onChange={(e) => setType(e.target.value)}
//                 placeholder="Enter event type"
//                 disabled={!userCanEdit}
//               />
//             </div>

//             <div className="form-group">
//               <label>Start Date & Time</label>
//               <div className="row">
//                 <div className="col-md-6">
//                   <input
//                     type="date"
//                     className="form-control"
//                     value={startDate}
//                     onChange={(e) => setStartDate(e.target.value)}
//                     disabled={!userCanEdit}
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <TimeSelect
//                     value={startTime}
//                     onChange={setStartTime}
//                     tenantTimezone={tenantTimezone}
//                     showTimezone={true}
//                     disabled={!userCanEdit}
//                   />
//                 </div>
//               </div>
//               <small className="form-hint text-muted">
//                 ⏰ Times are in 5-minute increments only
//               </small>
//             </div>

//             <div className="form-group">
//               <label>End Date & Time</label>
//               <div className="row">
//                 <div className="col-md-6">
//                   <input
//                     type="date"
//                     className="form-control"
//                     value={endDate}
//                     onChange={(e) => setEndDate(e.target.value)}
//                     disabled={!userCanEdit}
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <TimeSelect
//                     value={endTime}
//                     onChange={setEndTime}
//                     tenantTimezone={tenantTimezone}
//                     showTimezone={true}
//                     disabled={!userCanEdit}
//                   />
//                 </div>
//               </div>
//               <small className="form-hint text-muted">
//                 ⏰ Times are in 5-minute increments only
//               </small>
//             </div>
//           </form>

//           {/* Event-level media gallery */}
//           <h3 style={{ padding: "12px", marginTop: 12 }}>Event Media</h3>
//           {eventMedia.length ? (
//             <div className="feed" style={{ padding: 0 }}>
//               {eventMedia.map((m, idx) => (
//                 <article
//                   key={`event-${idx}`}
//                   className="feed-card"
//                   style={{
//                     padding: 0,
//                     border: "1px solid rgba(0,0,0,0.15)",
//                     borderRadius: 12,
//                     overflow: "hidden",
//                   }}
//                 >
//                   {/* Media display */}
//                   {m.isVideo ? (
//                     <video
//                       className="feed-media"
//                       src={m.url}
//                       controls
//                       preload="metadata"
//                       playsInline
//                       {...videoFixProps}
//                     />
//                   ) : (
//                     <img
//                       className="feed-media"
//                       src={m.url}
//                       alt=""
//                       onError={(e) => (e.currentTarget.src = toAbs(baseUrl, "/public/app/default-image.png"))}
//                     />
//                   )}

//                   {/* Controls BELOW the media */}
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "space-between",
//                       padding: "8px 12px",
//                       background: "rgba(255,255,255,0.96)",
//                       borderTop: "1px solid rgba(0,0,0,0.08)",
//                     }}
//                   >
//                     <label className="flex items-center gap-2 text-sm">
//                       <input
//                         type="checkbox"
//                         checked={!!selectedMedia[m.url]}
//                         onChange={() => toggleSelect(m.url)}
//                         style={{ width: 16, height: 16 }}
//                       />
//                       Select
//                     </label>
                    

//                   </div>
//                 </article>
//               ))}
//             </div>
//           ) : (
//             <p style={{ padding: "0 12px" }}>No media available for this event.</p>
//           )}

//           {/* Event items section */}
//           <h3 style={{ padding: "12px", marginTop: 12 }}>Event Items</h3>
//           {(eventItems || []).map((item) => {
//             const imgs = eventItemImages[item.id] || [];
//             const vids = eventItemVideos[item.id] || [];
//             const media = [
//               ...imgs.filter(isImage).map((i) => ({ url: toAbs(baseUrl, i.path), isVideo: false })),
//               ...vids.filter(isVideo).map((v) => ({ url: toAbs(baseUrl, v.path), isVideo: true })),
//             ];
//             if (!media.length) return null;

//             const toDetail = `/${tenant}/${eventId}/${item.id}/eventItemDetail`;

//             return (
//               <section key={`item-${item.id}`} style={{ marginBottom: 12 }}>
//                 <Link
//                   to={toDetail}
//                   className="text-decoration-none"
//                   style={{ display: "inline-block", margin: "0 12px 8px" }}
//                 >
//                   <strong>{item.name || `Item #${item.id}`}</strong>
//                 </Link>

//                 <div className="feed" style={{ padding: 0 }}>
//                   {media.map((m, idx) => (
//                     <article
//                       key={`${item.id}-${idx}`}
//                       className="feed-card"
//                       style={{
//                         padding: 0,
//                         border: "1px solid rgba(0,0,0,0.15)",
//                         borderRadius: 12,
//                         overflow: "hidden",
//                         cursor: "pointer",
//                       }}
//                       onClick={() => navigate(toDetail)}
//                       role="button"
//                       tabIndex={0}
//                       onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && navigate(toDetail)}
//                     >
//                       {m.isVideo ? (
//                         <video
//                           className="feed-media"
//                           src={m.url}
//                           controls
//                           preload="metadata"
//                           playsInline
//                           {...videoFixProps}
//                         />
//                       ) : (
//                         <img
//                           className="feed-media"
//                           src={m.url}
//                           alt=""
//                           onError={(e) =>
//                             (e.currentTarget.src = toAbs(baseUrl, "/public/app/default-image.png"))
//                           }
//                         />
//                       )}

//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "space-between",
//                           padding: "8px 12px",
//                           background: "rgba(255,255,255,0.96)",
//                           borderTop: "1px solid rgba(0,0,0,0.08)",
//                         }}
//                         onClick={(e) => e.stopPropagation()}
//                       >
//                         <label className="flex items-center gap-2 text-sm">
//                           <input
//                             type="checkbox"
//                             checked={!!selectedMedia[m.url]}
//                             onChange={() => toggleSelect(m.url)}
//                             style={{ width: 16, height: 16 }}
//                           />
//                           Select
//                         </label>
                        

//                       </div>
//                     </article>
//                   ))}
//                 </div>
//               </section>
//             );
//           })}

//           {registerStatus && <p className="mt-3" style={{ padding: "0 12px" }}>{registerStatus}</p>}
          
//           {/* Comments section */}
//           <CommentsPanel baseUrl={baseUrl} tenantId={tenant} eventId={eventId} />
//         </>
//       ) : (
//         <p>Loading event details...</p>
//       )}

//       {/* Footer with dynamic buttons */}
//       <AppFooter
//         buttons={[
//           {
//             icon: <FaArrowLeft />,
//             label: "Back",
//             onClick: () => navigate(-1),
//           },
//           { 
//             icon: <FaPlus />, 
//             label: "Add Item", 
//             onClick: () => handleItem(true) 
//           },
//           { 
//             icon: <FaTasks />, 
//             label: "Task", 
//             onClick: () => handleTask(true) 
//           },
//           ...(selectedCount > 0 ? [{
//             icon: <FaShare />,
//             label: `Post (${selectedCount})`,
//             onClick: () => setPostChoiceOpen(true),
//           }] : [{
//             icon: <FaShare />,
//             label: "Post",
//             onClick: () => setPostChoiceOpen(true),
//           }]),
//           ...(selectedCount > 0 ? [{
//             icon: <FaTrash />,
//             label: `Delete (${selectedCount})`,
//             onClick: handleDeleteSelected,
//           }] : []),
//           { 
//             icon: <FaSave />, 
//             label: "Save", 
//             onClick: updateEvent, 
//             type: "submit", 
//             disabled: !userCanEdit 
//           },
//         ]}
//       />

//       {/* Post choice modal */}
//       {postChoiceOpen && (
//         <PostChoiceModal
//           isOpen={postChoiceOpen}
//           onClose={() => setPostChoiceOpen(false)}
//           title={selectedCount > 0 ? "Post Selected Media" : "Event Post"}
//           hint={selectedCount > 0 
//             ? `Post ${selectedCount} selected media item(s) now or schedule a post.` 
//             : "Post now (opens your full post flow) or schedule a post."}
//           onPostNow={() => { 
//             setPostChoiceOpen(false); 
//             if (selectedCount > 0) {
//               handlePostSelected();
//             } else {
//               navigate(`/${tenant}/${eventId}/mediaPost`, {
//                 state: {
//                   context: "event",
//                   tenant,
//                   eventId,
//                   title: name || "",
//                   description: description || "",
//                   event,
//                 },
//               });
//             }
//           }}
//           onSchedule={() => {
//             setPostChoiceOpen(false);
            
//             if (selectedCount > 0) {
//               const selectedUrls = Object.keys(selectedMedia).filter((url) => selectedMedia[url]);
//               const toPublic = (p) => (p?.startsWith("/public/") ? p : p?.startsWith("/tenants/") ? `/public${p}` : p);
              
//               const selectedImages = [];
//               const selectedVideos = [];

//               eventImages.forEach((img) => {
//                 const url = toAbs(baseUrl, img.path || img.url || img);
//                 if (selectedUrls.includes(url)) {
//                   selectedImages.push(toPublic(img.path || img.url || img));
//                 }
//               });

//               eventVideos.forEach((vid) => {
//                 const url = toAbs(baseUrl, vid.path || vid.url || vid);
//                 if (selectedUrls.includes(url)) {
//                   selectedVideos.push(toPublic(vid.path || vid.url || vid));
//                 }
//               });

//               Object.keys(eventItemImages).forEach((itemId) => {
//                 eventItemImages[itemId].forEach((img) => {
//                   const url = toAbs(baseUrl, img.path || img.url || img);
//                   if (selectedUrls.includes(url)) {
//                     selectedImages.push(toPublic(img.path || img.url || img));
//                   }
//                 });
//               });

//               Object.keys(eventItemVideos).forEach((itemId) => {
//                 eventItemVideos[itemId].forEach((vid) => {
//                   const url = toAbs(baseUrl, vid.path || vid.url || vid);
//                   if (selectedUrls.includes(url)) {
//                     selectedVideos.push(toPublic(vid.path || vid.url || vid));
//                   }
//                 });
//               });

//               navigate(`/${tenant}/${eventId}/schedulePost`, {
//                 state: {
//                   context: "event",
//                   tenant,
//                   eventId,
//                   title: name || "",
//                   description: description || "",
//                   image: selectedImages[0] || "",
//                   images: selectedImages,
//                   videos: selectedVideos,
//                   event,
//                 },
//               });
//             } else {
//               navigate(`/${tenant}/${eventId}/schedulePost`);
//             }
//           }}
//         />
//       )}

//       {/* Confirm Delete Modal */}
//       <ConfirmDeleteModal
//         isOpen={showDeleteModal}
//         onClose={() => setShowDeleteModal(false)}
//         onConfirm={performDelete}
//         count={Object.values(selectedMedia).filter(Boolean).length}
//         context="event"
//       />

//       {/* Invite Collaborator Modal */}
//       <InviteCollaboratorModal
//         tenantIdForRoutes={tenant}
//         eventId={eventId}
//         open={inviteOpen}
//         onClose={() => setInviteOpen(false)}
//         onInvited={() => {}}
//       />
//     </div>
//   );
// };

// export default EventDetail;

// // client/src/components/events/EventDetail.jsx
// import React, { useEffect, useMemo, useState } from "react";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import AppFooter from "../AppFooter";
// import { FaEnvelope, FaPlus, FaSave, FaShare, FaTimes, FaTasks, FaTrash, FaArrowLeft } from "react-icons/fa";
// import CommentsPanel from "../comments/CommentsPanel";
// import PostChoiceModal from "../media/PostChoiceModal";
// import { useMessagesUI } from "../../context/MessagesContext";
// import { useWebShare } from "../../hooks/useWebShare";
// import MediaTile from "../media/MediaTile";
// import { sessionRequestConfig, getSessionLocal, canEditFromSession, isEditRoleName } from "../../services/sessionLocal";
// import CollaboratorsPanel from "../event/CollaboratorsPanel";
// import InviteCollaboratorModal from "../event/InviteCollaboratorModal";
// import TimeSelect from "../TimeSelect";
// import { localToUTC } from "../../utils/timezoneUtils";

// /* ---------- small helper for multi-try requests ---------- */
// const fetchFirst = async (attempts) => {
//   let lastErr;
//   for (const attempt of attempts) {
//     try { return await attempt(); } catch (e) { lastErr = e; }
//   }
//   throw lastErr || new Error("All requests failed");
// };

// /* ---------- helpers ---------- */
// const toAbs = (baseUrl, p) =>
//   !p ? p : /^https?:\/\//i.test(p) ? p : `${baseUrl}${p.startsWith('/') ? '' : '/'}${p}`;
// const isImage = (f) =>
//   (f?.mimetype?.startsWith?.("image/")) || /\.(png|jpe?g|gif|webp|svg|bmp)$/i.test(f?.path || f || "");
// const isVideo = (f) =>
//   (f?.mimetype?.startsWith?.("video/")) || /\.(mp4|mov|webm|ogg|avi|mkv)$/i.test(f?.path || f || "");

// const videoFixProps = {
//   playsInline: true,
//   preload: "metadata",
//   crossOrigin: "anonymous",
//   onLoadedMetadata: (e) => {
//     try {
//       // iOS/Safari first-frame fix to avoid black poster
//       if (e.currentTarget.currentTime === 0) e.currentTarget.currentTime = 0.1;
//     } catch {}
//   },
// };

// const EventDetail = () => {
//   const [event, setEvent] = useState(null);
//   const [registerStatus, setRegisterStatus] = useState("");

//   // Event fields matching EventAdd
//   const [name, setName] = useState('');
//   const [description, setDescription] = useState('');
//   const [type, setType] = useState('');
//   const [startDate, setStartDate] = useState('');
//   const [startTime, setStartTime] = useState('09:00');
//   const [endDate, setEndDate] = useState('');
//   const [endTime, setEndTime] = useState('17:00');
//   const [tenantTimezone, setTenantTimezone] = useState('America/Chicago');

//   // event-level media
//   const [eventImages, setEventImages] = useState([]);
//   const [eventVideos, setEventVideos] = useState([]);

//   // item list + item-level media
//   const [eventItems, setEventItems] = useState([]);
//   const [eventItemImages, setEventItemImages] = useState({});
//   const [eventItemVideos, setEventItemVideos] = useState({});

//   // used by UI and post flow
//   const [images, setImages] = useState([]);
//   const [videos, setVideos] = useState([]);

//   const [loading, setLoading] = useState(true);
//   const [messages, setMessages] = useState([]);
//   const [newMessage, setNewMessage] = useState("");
//   const [postChoiceOpen, setPostChoiceOpen] = useState(false);

//   const [collabRole, setCollabRole] = useState(null);
//   const me = getSessionLocal();
//   const userCanEdit = useMemo(() => {
//     const iOwnThisEvent = Number(event?.tenantid) === Number(me.tenantId);
//     const collabEdit = isEditRoleName(collabRole) || collabRole === "editor";
//     return iOwnThisEvent || collabEdit || canEditFromSession();
//   }, [collabRole, event?.tenantid, me.tenantId]);

//   const [inviteOpen, setInviteOpen] = useState(false);

//   const navigate = useNavigate();
//   const { tenant, eventId } = useParams();
//   const baseUrl =
//     process.env.REACT_APP_BASE_URL ||
//     (typeof window !== "undefined" ? window.location.origin : "http://localhost:5000");
//   const { openMessages } = useMessagesUI();
//   const { share } = useWebShare();
  
//   // Media selection state - stores selected media URLs
//   const [selectedMedia, setSelectedMedia] = useState({}); // { [url]: true }
  
//   // Toggle selection for a single media item
//   const toggleSelect = (url) => setSelectedMedia((prev) => ({ ...prev, [url]: !prev[url] }));
  
//   const cfg = sessionRequestConfig();

//   /* ---- load my role (with session headers) ---- */
//   useEffect(() => {
//     let alive = true;
//     const cfg = sessionRequestConfig();
//     axios.get(`/api/collab/events/${eventId}/my-role`, cfg)
//       .then(({ data }) => { if (alive) setCollabRole(data?.role || null); })
//       .catch(() => { if (alive) setCollabRole(null); });
//     return () => { alive = false; };
//   }, [eventId]);

//   /* ---- Fetch tenant timezone ---- */
//   useEffect(() => {
//     const fetchTenantTimezone = async () => {
//       try {
//         const response = await axios.get(
//           `${baseUrl}/api/tenants/${tenant}/timezone`,
//           { withCredentials: true }
//         );
//         if (response.data.timezone) {
//           setTenantTimezone(response.data.timezone);
//         }
//       } catch (err) {
//         console.error('Failed to fetch tenant timezone:', err);
//         const browserTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
//         setTenantTimezone(browserTZ);
//       }
//     };
    
//     fetchTenantTimezone();
//   }, [tenant, baseUrl]);

//   /* ---- load event + media + items ---- */
//   useEffect(() => {
//     document.body.classList.add("eventlist-fullbleed");
//     return () => document.body.classList.remove("eventlist-fullbleed");
//   }, []);

//   useEffect(() => {
//     let alive = true;
//     (async () => {
//       try {
//         setLoading(true);

//         // event
//         const { data: eData } = await fetchFirst([
//           () => axios.get(`/api/events/${tenant}/events/${eventId}`, cfg),
//           () => axios.get(`/api/events/${tenant}/${eventId}`, cfg),
//           () => axios.get(`/api/${tenant}/events/${eventId}`, cfg),
//         ]);
//         if (!alive) return;
//         const e = eData?.event || eData || {};
//         setEvent(e);

//         // Populate form fields from loaded event
//         setName(e.name || '');
//         setDescription(e.description || '');
//         setType(e.type || '');
        
//         // Parse dates and times
//         if (e.startdate) {
//           const startDT = new Date(e.startdate);
//           setStartDate(startDT.toISOString().split('T')[0]);
//           setStartTime(startDT.toTimeString().slice(0, 5)); // HH:MM
//         }
//         if (e.enddate) {
//           const endDT = new Date(e.enddate);
//           setEndDate(endDT.toISOString().split('T')[0]);
//           setEndTime(endDT.toTimeString().slice(0, 5)); // HH:MM
//         }

//         // event images
//         const { data: imgData } = await fetchFirst([
//           () => axios.get(`/api/events/${tenant}/events/${eventId}/images`, cfg),
//           () => axios.get(`/api/events/${tenant}/${eventId}/images`, cfg),
//           () => axios.get(`/api/${tenant}/${eventId}/images`, cfg),
//         ]);
//         if (!alive) return;
//         setEventImages(imgData?.images || []);

//         // items
//         const { data: itemsData } = await fetchFirst([
//           () => axios.get(`/api/events/${tenant}/events/${eventId}/items`, cfg),
//           () => axios.get(`/api/events/${tenant}/${eventId}/items`, cfg),
//           () => axios.get(`/api/${tenant}/${eventId}/items`, cfg),
//         ]);
//         if (!alive) return;
//         const items = itemsData?.items || [];
//         setEventItems(items);

//         const itemImagesMap = {};
//         const itemVideosMap = {};
//         await Promise.all(
//           items.map(async (it) => {
//             // images
//             try {
//               const { data } = await fetchFirst([
//                 () => axios.get(`/api/events/${tenant}/events/${eventId}/items/${it.id}/images`, cfg),
//                 () => axios.get(`/api/events/${tenant}/${eventId}/items/${it.id}/images`, cfg),
//                 () => axios.get(`/api/${tenant}/${eventId}/items/${it.id}/images`, cfg),
//               ]);
//               itemImagesMap[it.id] = data?.images || [];
//             } catch { itemImagesMap[it.id] = []; }
      
//             // videos
//             try {
//               const { data } = await fetchFirst([
//                 () => axios.get(`/api/${tenant}/events/${eventId}/items/${it.id}/videos`, cfg),
//                 () => axios.get(`/api/events/${tenant}/events/${eventId}/items/${it.id}/videos`, cfg),
//                 () => axios.get(`/api/events/${tenant}/${eventId}/items/${it.id}/videos`, cfg),
//               ]);
//               itemVideosMap[it.id] = data?.videos || [];
//             } catch { itemVideosMap[it.id] = []; }
//           })
//         );
//         if (!alive) return;
//         setEventItemImages(itemImagesMap);
//         setEventItemVideos(itemVideosMap);
//       } catch (err) {
//         console.error("Error loading event data:", err);
//       } finally {
//         if (alive) setLoading(false);
//       }
//     })();
//     return () => { alive = false; };
//   }, [tenant, eventId]);

//   /* ---- load messages ---- */
//   useEffect(() => {
//     axios
//       .get(`${baseUrl}/api/events/${tenant}/events/${eventId}/messages`)
//       .then((res) => setMessages(Array.isArray(res.data) ? res.data : res.data?.messages || res.data || []))
//       .catch(() => setMessages([]));
//   }, [tenant, eventId, baseUrl]);

//   /* ---- helpers ---- */
//   const handleShare = async () => {
//     const eventUrl = `${window.location.origin}/${tenant}/${eventId}`;
//     try {
//       await share({ url: eventUrl, title: event?.name || "Event" });
//     } catch (err) {
//       console.error("Share error:", err);
//       navigator.clipboard?.writeText?.(eventUrl).then(() => {
//         alert("Event link copied to clipboard!");
//       });
//     }
//   };

//   const sendMessage = async () => {
//     if (!newMessage.trim()) return;
//     try {
//       const response = await axios.post(`${baseUrl}/api/events/${tenant}/events/${eventId}/messages`, {
//         message: newMessage,
//       });
//       if (response.data.success) {
//         setMessages([...messages, { message: newMessage }]);
//         setNewMessage("");
//       }
//     } catch (err) {
//       console.error("Error sending message:", err);
//     }
//   };

//   const updateEvent = async (e) => {
//     e?.preventDefault?.();
//     if (!name || !description) {
//       setRegisterStatus("Name and Description are required.");
//       return;
//     }
//     try {
//       // Convert to UTC before sending
//       const startDateTimeUTC = localToUTC(startDate, startTime, tenantTimezone);
//       const endDateTimeUTC = localToUTC(endDate, endTime, tenantTimezone);

//       const response = await axios.put(
//         `${baseUrl}/api/events/${tenant}/events/${eventId}`,
//         {
//           name,
//           description,
//           type,
//           startdate: startDateTimeUTC,
//           enddate: endDateTimeUTC,
//           timezone: tenantTimezone,
//         }
//       );
//       if (response.data.success) {
//         setRegisterStatus("Event updated successfully!");
//       } else {
//         setRegisterStatus("Failed to update event.");
//       }
//     } catch (error) {
//       console.error("Error updating event:", error);
//       setRegisterStatus("Error updating event.");
//     }
//   };

//   const handleCancel = () => navigate(`/${tenant}/event`);
//   const handleItem = () => navigate(`/${tenant}/${eventId}/eventItemAdd`);
//   // const handleTask = () => navigate(`/${tenant}/${eventId}/taskAdd`);
//   const handleTask = () => navigate(`/${tenant}/${eventId}/task`);

//   /**
//    * Handle posting selected media
//    */
//   const handlePostSelected = () => {
//     const selectedUrls = Object.keys(selectedMedia).filter((url) => selectedMedia[url]);
    
//     if (selectedUrls.length === 0) {
//       alert("Please select at least one media item to post.");
//       return;
//     }

//     const toPublic = (p) => (p?.startsWith("/public/") ? p : p?.startsWith("/tenants/") ? `/public${p}` : p);

//     const selectedImages = [];
//     const selectedVideos = [];

//     // Check event-level media
//     eventImages.forEach((img) => {
//       const url = toAbs(baseUrl, img.path || img.url || img);
//       if (selectedUrls.includes(url)) {
//         selectedImages.push(toPublic(img.path || img.url || img));
//       }
//     });

//     eventVideos.forEach((vid) => {
//       const url = toAbs(baseUrl, vid.path || vid.url || vid);
//       if (selectedUrls.includes(url)) {
//         selectedVideos.push(toPublic(vid.path || vid.url || vid));
//       }
//     });

//     // Check item-level media
//     Object.keys(eventItemImages).forEach((itemId) => {
//       eventItemImages[itemId].forEach((img) => {
//         const url = toAbs(baseUrl, img.path || img.url || img);
//         if (selectedUrls.includes(url)) {
//           selectedImages.push(toPublic(img.path || img.url || img));
//         }
//       });
//     });

//     Object.keys(eventItemVideos).forEach((itemId) => {
//       eventItemVideos[itemId].forEach((vid) => {
//         const url = toAbs(baseUrl, vid.path || vid.url || vid);
//         if (selectedUrls.includes(url)) {
//           selectedVideos.push(toPublic(vid.path || vid.url || vid));
//         }
//       });
//     });

//     const cover = selectedImages[0] || "";

//     navigate(`/${tenant}/${eventId}/mediaPost`, {
//       state: {
//         context: "event",
//         tenant,
//         eventId,
//         title: name || "",
//         description: description || "",
//         image: cover,
//         images: selectedImages,
//         videos: selectedVideos,
//         event,
//       },
//       replace: false,
//     });
//   };

//   /**
//    * Handle deleting selected media
//    */
//   const handleDeleteSelected = async () => {
//     const selectedUrls = Object.keys(selectedMedia).filter((url) => selectedMedia[url]);
    
//     if (selectedUrls.length === 0) {
//       alert("Please select at least one media item to delete.");
//       return;
//     }

//     if (!window.confirm(`Delete ${selectedUrls.length} selected media item(s)?`)) {
//       return;
//     }

//     try {
//       const eventMediaUrls = [];
//       const itemMediaUrls = {};

//       // Check event-level media
//       eventImages.forEach((img) => {
//         const url = toAbs(baseUrl, img.path || img.url || img);
//         if (selectedUrls.includes(url)) {
//           eventMediaUrls.push(url);
//         }
//       });

//       eventVideos.forEach((vid) => {
//         const url = toAbs(baseUrl, vid.path || vid.url || vid);
//         if (selectedUrls.includes(url)) {
//           eventMediaUrls.push(url);
//         }
//       });

//       // Check item-level media
//       Object.keys(eventItemImages).forEach((itemId) => {
//         eventItemImages[itemId].forEach((img) => {
//           const url = toAbs(baseUrl, img.path || img.url || img);
//           if (selectedUrls.includes(url)) {
//             if (!itemMediaUrls[itemId]) itemMediaUrls[itemId] = [];
//             itemMediaUrls[itemId].push(url);
//           }
//         });
//       });

//       Object.keys(eventItemVideos).forEach((itemId) => {
//         eventItemVideos[itemId].forEach((vid) => {
//           const url = toAbs(baseUrl, vid.path || vid.url || vid);
//           if (selectedUrls.includes(url)) {
//             if (!itemMediaUrls[itemId]) itemMediaUrls[itemId] = [];
//             itemMediaUrls[itemId].push(url);
//           }
//         });
//       });

//       // Call backend API for event-level media
//       if (eventMediaUrls.length > 0) {
//         const response = await axios.delete(
//           `${baseUrl}/api/events/${tenant}/events/${eventId}/media`,
//           { data: { urls: eventMediaUrls } }
//         );
        
//         if (!response.data.success) {
//           throw new Error(response.data.message || 'Failed to delete event media');
//         }
//       }

//       // Call backend API for item-level media
//       for (const itemId of Object.keys(itemMediaUrls)) {
//         const response = await axios.delete(
//           `${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}/media`,
//           { data: { urls: itemMediaUrls[itemId] } }
//         );
        
//         if (!response.data.success) {
//           throw new Error(response.data.message || `Failed to delete media for item ${itemId}`);
//         }
//       }

//       // Update UI state after successful deletion
//       setEventImages((prev) => 
//         (prev || []).filter((x) => !selectedUrls.includes(toAbs(baseUrl, x.path || x.url || x)))
//       );
//       setEventVideos((prev) => 
//         (prev || []).filter((x) => !selectedUrls.includes(toAbs(baseUrl, x.path || x.url || x)))
//       );

//       setEventItemImages((prev) => {
//         const next = { ...prev };
//         Object.keys(next).forEach((itemId) => {
//           next[itemId] = (next[itemId] || []).filter(
//             (x) => !selectedUrls.includes(toAbs(baseUrl, x.path || x.url || x))
//           );
//         });
//         return next;
//       });

//       setEventItemVideos((prev) => {
//         const next = { ...prev };
//         Object.keys(next).forEach((itemId) => {
//           next[itemId] = (next[itemId] || []).filter(
//             (x) => !selectedUrls.includes(toAbs(baseUrl, x.path || x.url || x))
//           );
//         });
//         return next;
//       });

//       // Clear selection
//       setSelectedMedia({});

//     } catch (error) {
//       console.error("Error deleting selected media:", error);
//       alert(`Failed to delete media: ${error.message || 'Unknown error'}. Please try again.`);
//     }
//   };

//   /**
//    * Handle deleting a single event-level media item
//    */
//   const handleDelete = async (url) => {
//     if (!window.confirm("Delete this media?")) return;
    
//     try {
//       const response = await axios.delete(
//         `${baseUrl}/api/events/${tenant}/events/${eventId}/media/single`,
//         { data: { url } }
//       );

//       if (!response.data.success) {
//         throw new Error(response.data.message || 'Failed to delete media');
//       }

//       setEventImages((prev) => (prev || []).filter((x) => toAbs(baseUrl, x.path || x.url || x) !== url));
//       setEventVideos((prev) => (prev || []).filter((x) => toAbs(baseUrl, x.path || x.url || x) !== url));
//       setSelectedMedia((prev) => { const n = { ...prev }; delete n[url]; return n; });

//     } catch (error) {
//       console.error("Error deleting media:", error);
//       alert(`Failed to delete media: ${error.message || 'Unknown error'}. Please try again.`);
//     }
//   };

//   /**
//    * Handle deleting a single item-level media item
//    */
//   const handleDeleteItemMedia = async (itemId, url) => {
//     if (!window.confirm("Delete this item media?")) return;
    
//     try {
//       const response = await axios.delete(
//         `${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}/media/single`,
//         { data: { url } }
//       );

//       if (!response.data.success) {
//         throw new Error(response.data.message || 'Failed to delete item media');
//       }

//       setEventItemImages((prev) => {
//         const next = { ...prev };
//         next[itemId] = (next[itemId] || []).filter((x) => toAbs(baseUrl, x.path || x.url || x) !== url);
//         return next;
//       });
//       setEventItemVideos((prev) => {
//         const next = { ...prev };
//         next[itemId] = (next[itemId] || []).filter((x) => toAbs(baseUrl, x.path || x.url || x) !== url);
//         return next;
//       });
//       setSelectedMedia((prev) => { const n = { ...prev }; delete n[url]; return n; });

//     } catch (error) {
//       console.error("Error deleting item media:", error);
//       alert(`Failed to delete item media: ${error.message || 'Unknown error'}. Please try again.`);
//     }
//   };

//   if (loading) return <p>Loading event details...</p>;

//   /* ---- merged gallery for the event ---- */
//   const imgSrcs = (eventImages?.length ? eventImages : (event?.files || []))
//     .filter((f) => isImage?.(f) ?? /\.(png|jpe?g|gif|webp|svg)$/i.test(f?.path || f || ""))
//     .map((i) => ({ url: toAbs(baseUrl, i.path || i.url || i), isVideo: false }));
//   const vidSrcs = (eventVideos?.length ? eventVideos : (event?.files || []))
//     .filter((f) => isVideo?.(f) ?? /\.(mp4|mov|webm|ogg)$/i.test(f?.path || f || ""))
//     .map((v) => ({ url: toAbs(baseUrl, v.path || v.url || v), isVideo: true }));
//   const eventMedia = [...imgSrcs, ...vidSrcs];

//   // Count selected media
//   const selectedCount = Object.values(selectedMedia).filter(Boolean).length;

//   return (
//     <div className="container">
//       <h2 className="hdr hdr--primary hdr--lg">Event Details</h2>

//       {/* Collaboration header */}
//       <div className="flex items-center gap-2" style={{ padding: "0 12px 8px" }}>
//         <span className="text-sm text-neutral-600 dark:text-neutral-300">Collaboration</span>
//         {userCanEdit && (
//           <button
//             type="button"
//             className="btn btn-sm btn-outline"
//             onClick={() => setInviteOpen(true)}
//             title="Invite collaborators"
//           >
//             <FaPlus className="inline mr-1" />
//             Invite
//           </button>
//         )}
//       </div>

//       {/* CollaboratorsPanel */}
//       <CollaboratorsPanel
//         tenantIdForRoutes={tenant}
//         eventId={eventId}
//         currentUserId={me.userId}
//         canManage={userCanEdit}
//       />

//       {!loading ? (
//         <>
//           {/* Selected media count indicator */}
//           {selectedCount > 0 && (
//             <div
//               style={{
//                 padding: "8px 12px",
//                 margin: "8px 12px",
//                 background: "#ff6800",
//                 color: "white",
//                 borderRadius: "8px",
//                 fontSize: "14px",
//                 fontWeight: "600",
//               }}
//             >
//               {selectedCount} media item{selectedCount !== 1 ? "s" : ""} selected
//             </div>
//           )}

//           {/* Event form fields - matching EventAdd styling */}
//           <form onSubmit={updateEvent}>
//             <div className="form-group">
//               <label htmlFor="name">Event Name</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 id="name"
//                 name="name"
//                 value={name}
//                 onChange={(e) => setName(e.target.value)}
//                 placeholder="Enter event name"
//                 disabled={!userCanEdit}
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label htmlFor="description">Event Description</label>
//               <textarea
//                 className="form-control"
//                 id="description"
//                 name="description"
//                 value={description}
//                 onChange={(e) => setDescription(e.target.value)}
//                 placeholder="Enter event description"
//                 rows={4}
//                 disabled={!userCanEdit}
//               />
//             </div>

//             <div className="form-group">
//               <label htmlFor="type">Event Type</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 id="type"
//                 name="type"
//                 value={type}
//                 onChange={(e) => setType(e.target.value)}
//                 placeholder="Enter event type"
//                 disabled={!userCanEdit}
//               />
//             </div>

//             <div className="form-group">
//               <label>Start Date & Time</label>
//               <div className="row">
//                 <div className="col-md-6">
//                   <input
//                     type="date"
//                     className="form-control"
//                     value={startDate}
//                     onChange={(e) => setStartDate(e.target.value)}
//                     disabled={!userCanEdit}
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <TimeSelect
//                     value={startTime}
//                     onChange={setStartTime}
//                     tenantTimezone={tenantTimezone}
//                     showTimezone={true}
//                     disabled={!userCanEdit}
//                   />
//                 </div>
//               </div>
//               <small className="form-hint text-muted">
//                 ⏰ Times are in 5-minute increments only
//               </small>
//             </div>

//             <div className="form-group">
//               <label>End Date & Time</label>
//               <div className="row">
//                 <div className="col-md-6">
//                   <input
//                     type="date"
//                     className="form-control"
//                     value={endDate}
//                     onChange={(e) => setEndDate(e.target.value)}
//                     disabled={!userCanEdit}
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <TimeSelect
//                     value={endTime}
//                     onChange={setEndTime}
//                     tenantTimezone={tenantTimezone}
//                     showTimezone={true}
//                     disabled={!userCanEdit}
//                   />
//                 </div>
//               </div>
//               <small className="form-hint text-muted">
//                 ⏰ Times are in 5-minute increments only
//               </small>
//             </div>
//           </form>

//           {/* Event-level media gallery */}
//           <h3 style={{ padding: "12px", marginTop: 12 }}>Event Media</h3>
//           {eventMedia.length ? (
//             <div className="feed" style={{ padding: 0 }}>
//               {eventMedia.map((m, idx) => (
//                 <article
//                   key={`event-${idx}`}
//                   className="feed-card"
//                   style={{
//                     padding: 0,
//                     border: "1px solid rgba(0,0,0,0.15)",
//                     borderRadius: 12,
//                     overflow: "hidden",
//                   }}
//                 >
//                   {/* Media display */}
//                   {m.isVideo ? (
//                     <video
//                       className="feed-media"
//                       src={m.url}
//                       controls
//                       preload="metadata"
//                       playsInline
//                       {...videoFixProps}
//                     />
//                   ) : (
//                     <img
//                       className="feed-media"
//                       src={m.url}
//                       alt=""
//                       onError={(e) => (e.currentTarget.src = toAbs(baseUrl, "/public/app/default-image.png"))}
//                     />
//                   )}

//                   {/* Controls BELOW the media */}
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "space-between",
//                       padding: "8px 12px",
//                       background: "rgba(255,255,255,0.96)",
//                       borderTop: "1px solid rgba(0,0,0,0.08)",
//                     }}
//                   >
//                     <label className="flex items-center gap-2 text-sm">
//                       <input
//                         type="checkbox"
//                         checked={!!selectedMedia[m.url]}
//                         onChange={() => toggleSelect(m.url)}
//                         style={{ width: 16, height: 16 }}
//                       />
//                       Select
//                     </label>
                    
//                     <button
//                       type="button"
//                       aria-label="Delete media"
//                       onClick={() => handleDelete(m.url)}
//                       className="btn btn-sm btn-outline"
//                       style={{ width: "auto" }}
//                     >
//                       Delete
//                     </button>
//                   </div>
//                 </article>
//               ))}
//             </div>
//           ) : (
//             <p style={{ padding: "0 12px" }}>No media available for this event.</p>
//           )}

//           {/* Event items section */}
//           <h3 style={{ padding: "12px", marginTop: 12 }}>Event Items</h3>
//           {(eventItems || []).map((item) => {
//             const imgs = eventItemImages[item.id] || [];
//             const vids = eventItemVideos[item.id] || [];
//             const media = [
//               ...imgs.filter(isImage).map((i) => ({ url: toAbs(baseUrl, i.path), isVideo: false })),
//               ...vids.filter(isVideo).map((v) => ({ url: toAbs(baseUrl, v.path), isVideo: true })),
//             ];
//             if (!media.length) return null;

//             const toDetail = `/${tenant}/${eventId}/${item.id}/eventItemDetail`;

//             return (
//               <section key={`item-${item.id}`} style={{ marginBottom: 12 }}>
//                 <Link
//                   to={toDetail}
//                   className="text-decoration-none"
//                   style={{ display: "inline-block", margin: "0 12px 8px" }}
//                 >
//                   <strong>{item.name || `Item #${item.id}`}</strong>
//                 </Link>

//                 <div className="feed" style={{ padding: 0 }}>
//                   {media.map((m, idx) => (
//                     <article
//                       key={`${item.id}-${idx}`}
//                       className="feed-card"
//                       style={{
//                         padding: 0,
//                         border: "1px solid rgba(0,0,0,0.15)",
//                         borderRadius: 12,
//                         overflow: "hidden",
//                         cursor: "pointer",
//                       }}
//                       onClick={() => navigate(toDetail)}
//                       role="button"
//                       tabIndex={0}
//                       onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && navigate(toDetail)}
//                     >
//                       {m.isVideo ? (
//                         <video
//                           className="feed-media"
//                           src={m.url}
//                           controls
//                           preload="metadata"
//                           playsInline
//                           {...videoFixProps}
//                         />
//                       ) : (
//                         <img
//                           className="feed-media"
//                           src={m.url}
//                           alt=""
//                           onError={(e) =>
//                             (e.currentTarget.src = toAbs(baseUrl, "/public/app/default-image.png"))
//                           }
//                         />
//                       )}

//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "space-between",
//                           padding: "8px 12px",
//                           background: "rgba(255,255,255,0.96)",
//                           borderTop: "1px solid rgba(0,0,0,0.08)",
//                         }}
//                         onClick={(e) => e.stopPropagation()}
//                       >
//                         <label className="flex items-center gap-2 text-sm">
//                           <input
//                             type="checkbox"
//                             checked={!!selectedMedia[m.url]}
//                             onChange={() => toggleSelect(m.url)}
//                             style={{ width: 16, height: 16 }}
//                           />
//                           Select
//                         </label>
                        
//                         <button
//                           type="button"
//                           aria-label="Delete item media"
//                           onClick={() => handleDeleteItemMedia(item.id, m.url)}
//                           className="btn btn-sm btn-outline"
//                           style={{ width: "auto" }}
//                         >
//                           Delete
//                         </button>
//                       </div>
//                     </article>
//                   ))}
//                 </div>
//               </section>
//             );
//           })}

//           {registerStatus && <p className="mt-3" style={{ padding: "0 12px" }}>{registerStatus}</p>}
          
//           {/* Comments section */}
//           <CommentsPanel baseUrl={baseUrl} tenantId={tenant} eventId={eventId} />
//         </>
//       ) : (
//         <p>Loading event details...</p>
//       )}

//       {/* Footer with dynamic buttons */}
//       <AppFooter
//         buttons={[
//           {
//             icon: <FaArrowLeft />,
//             label: "Back",
//             onClick: () => navigate(-1),
//           },
//           { 
//             icon: <FaPlus />, 
//             label: "Add Item", 
//             onClick: () => handleItem(true) 
//           },
//           { 
//             icon: <FaTasks />, 
//             label: "Task", 
//             onClick: () => handleTask(true) 
//           },
//           ...(selectedCount > 0 ? [{
//             icon: <FaShare />,
//             label: `Post (${selectedCount})`,
//             onClick: () => setPostChoiceOpen(true),
//           }] : [{
//             icon: <FaShare />,
//             label: "Post",
//             onClick: () => setPostChoiceOpen(true),
//           }]),
//           ...(selectedCount > 0 ? [{
//             icon: <FaTrash />,
//             label: `Delete (${selectedCount})`,
//             onClick: handleDeleteSelected,
//           }] : []),
//           { 
//             icon: <FaSave />, 
//             label: "Save", 
//             onClick: updateEvent, 
//             type: "submit", 
//             disabled: !userCanEdit 
//           },
//         ]}
//       />

//       {/* Post choice modal */}
//       {postChoiceOpen && (
//         <PostChoiceModal
//           isOpen={postChoiceOpen}
//           onClose={() => setPostChoiceOpen(false)}
//           title={selectedCount > 0 ? "Post Selected Media" : "Event Post"}
//           hint={selectedCount > 0 
//             ? `Post ${selectedCount} selected media item(s) now or schedule a post.` 
//             : "Post now (opens your full post flow) or schedule a post."}
//           onPostNow={() => { 
//             setPostChoiceOpen(false); 
//             if (selectedCount > 0) {
//               handlePostSelected();
//             } else {
//               navigate(`/${tenant}/${eventId}/mediaPost`, {
//                 state: {
//                   context: "event",
//                   tenant,
//                   eventId,
//                   title: name || "",
//                   description: description || "",
//                   event,
//                 },
//               });
//             }
//           }}
//           onSchedule={() => {
//             setPostChoiceOpen(false);
            
//             if (selectedCount > 0) {
//               const selectedUrls = Object.keys(selectedMedia).filter((url) => selectedMedia[url]);
//               const toPublic = (p) => (p?.startsWith("/public/") ? p : p?.startsWith("/tenants/") ? `/public${p}` : p);
              
//               const selectedImages = [];
//               const selectedVideos = [];

//               eventImages.forEach((img) => {
//                 const url = toAbs(baseUrl, img.path || img.url || img);
//                 if (selectedUrls.includes(url)) {
//                   selectedImages.push(toPublic(img.path || img.url || img));
//                 }
//               });

//               eventVideos.forEach((vid) => {
//                 const url = toAbs(baseUrl, vid.path || vid.url || vid);
//                 if (selectedUrls.includes(url)) {
//                   selectedVideos.push(toPublic(vid.path || vid.url || vid));
//                 }
//               });

//               Object.keys(eventItemImages).forEach((itemId) => {
//                 eventItemImages[itemId].forEach((img) => {
//                   const url = toAbs(baseUrl, img.path || img.url || img);
//                   if (selectedUrls.includes(url)) {
//                     selectedImages.push(toPublic(img.path || img.url || img));
//                   }
//                 });
//               });

//               Object.keys(eventItemVideos).forEach((itemId) => {
//                 eventItemVideos[itemId].forEach((vid) => {
//                   const url = toAbs(baseUrl, vid.path || vid.url || vid);
//                   if (selectedUrls.includes(url)) {
//                     selectedVideos.push(toPublic(vid.path || vid.url || vid));
//                   }
//                 });
//               });

//               navigate(`/${tenant}/${eventId}/schedulePost`, {
//                 state: {
//                   context: "event",
//                   tenant,
//                   eventId,
//                   title: name || "",
//                   description: description || "",
//                   image: selectedImages[0] || "",
//                   images: selectedImages,
//                   videos: selectedVideos,
//                   event,
//                 },
//               });
//             } else {
//               navigate(`/${tenant}/${eventId}/schedulePost`);
//             }
//           }}
//         />
//       )}

//       {/* Invite Collaborator Modal */}
//       <InviteCollaboratorModal
//         tenantIdForRoutes={tenant}
//         eventId={eventId}
//         open={inviteOpen}
//         onClose={() => setInviteOpen(false)}
//         onInvited={() => {}}
//       />
//     </div>
//   );
// };

// export default EventDetail;


// client/src/components/events/EventDetail.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import AppFooter from "../AppFooter";
import { FaEnvelope, FaPlus, FaSave, FaShare, FaTimes, FaTasks, FaTrash, FaArrowLeft } from "react-icons/fa";
import CommentsPanel from "../comments/CommentsPanel";
import PostChoiceModal from "../media/PostChoiceModal";
import { useMessagesUI } from "../../context/MessagesContext";
import { useWebShare } from "../../hooks/useWebShare";
import MediaTile from "../media/MediaTile";
import { sessionRequestConfig, getSessionLocal, canEditFromSession, isEditRoleName } from "../../services/sessionLocal";
import CollaboratorsPanel from "../event/CollaboratorsPanel";
import InviteCollaboratorModal from "../event/InviteCollaboratorModal";
import TimeSelect from "../TimeSelect";
import { localToUTC } from "../../utils/timezoneUtils";
import ConfirmDeleteModal from "../../modals/ConfirmDeleteModal";
import MediaEditor from "../media/MediaEditor";

/* ---------- small helper for multi-try requests ---------- */
const fetchFirst = async (attempts) => {
  let lastErr;
  for (const attempt of attempts) {
    try { return await attempt(); } catch (e) { lastErr = e; }
  }
  throw lastErr || new Error("All requests failed");
};

/* ---------- helpers ---------- */
const toAbs = (baseUrl, p) =>
  !p ? p : /^https?:\/\//i.test(p) ? p : `${baseUrl}${p.startsWith('/') ? '' : '/'}${p}`;
const isImage = (f) =>
  (f?.mimetype?.startsWith?.("image/")) || /\.(png|jpe?g|gif|webp|svg|bmp)$/i.test(f?.path || f || "");
const isVideo = (f) =>
  (f?.mimetype?.startsWith?.("video/")) || /\.(mp4|mov|webm|ogg|avi|mkv)$/i.test(f?.path || f || "");

const videoFixProps = {
  playsInline: true,
  preload: "metadata",
  crossOrigin: "anonymous",
  onLoadedMetadata: (e) => {
    try {
      // iOS/Safari first-frame fix to avoid black poster
      if (e.currentTarget.currentTime === 0) e.currentTarget.currentTime = 0.1;
    } catch {}
  },
};

const EventDetail = () => {
  const [event, setEvent] = useState(null);
  const [registerStatus, setRegisterStatus] = useState("");

  // Event fields matching EventAdd
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [type, setType] = useState('');
  const [startDate, setStartDate] = useState('');
  const [startTime, setStartTime] = useState('09:00');
  const [endDate, setEndDate] = useState('');
  const [endTime, setEndTime] = useState('17:00');
  const [tenantTimezone, setTenantTimezone] = useState('America/Chicago');

  // event-level media
  const [eventImages, setEventImages] = useState([]);
  const [eventVideos, setEventVideos] = useState([]);

  // item list + item-level media
  const [eventItems, setEventItems] = useState([]);
  const [eventItemImages, setEventItemImages] = useState({});
  const [eventItemVideos, setEventItemVideos] = useState({});

  // used by UI and post flow
  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);

  const [loading, setLoading] = useState(true);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [postChoiceOpen, setPostChoiceOpen] = useState(false);

  const [collabRole, setCollabRole] = useState(null);
  const me = getSessionLocal();
  const userCanEdit = useMemo(() => {
    const iOwnThisEvent = Number(event?.tenantid) === Number(me.tenantId);
    const collabEdit = isEditRoleName(collabRole) || collabRole === "editor";
    return iOwnThisEvent || collabEdit || canEditFromSession();
  }, [collabRole, event?.tenantid, me.tenantId]);

  const [inviteOpen, setInviteOpen] = useState(false);

  const navigate = useNavigate();
  const { tenant, eventId } = useParams();
  const baseUrl =
    process.env.REACT_APP_BASE_URL ||
    (typeof window !== "undefined" ? window.location.origin : "http://localhost:5000");
  const { openMessages } = useMessagesUI();
  const { share } = useWebShare();
  
  // Media selection state - stores selected media URLs
  const [selectedMedia, setSelectedMedia] = useState({}); // { [url]: true }
  
  // Toggle selection for a single media item
  const toggleSelect = (url) => setSelectedMedia((prev) => ({ ...prev, [url]: !prev[url] }));
  
  /**
   * Handle opening media editor for a specific image
   * @param {string} url - The URL of the image to edit
   * @param {string} context - 'event' or 'item'
   * @param {number} itemId - Optional item ID if editing item media
   */
  const handleEditMedia = (url, context = 'event', itemId = null) => {
    if (!url) return;
    setEditingMedia({ url, context, itemId });
  };

  /**
   * Handle successful save from media editor
   * Replaces the old URL with the new edited URL in the appropriate state
   * @param {string} newUrl - The URL of the newly saved edited image
   */
  const handleMediaSaved = async (newUrl) => {
    if (!editingMedia) return;

    const { url: oldUrl, context, itemId: editItemId } = editingMedia;

    try {
      console.log('✓ Media saved, updating UI:', { oldUrl, newUrl, context, editItemId });

      if (context === 'event') {
        // Update event-level images
        setEventImages(prev => 
          prev.map(img => 
            toAbs(baseUrl, img.path) === oldUrl 
              ? { ...img, path: newUrl.replace(baseUrl, '') }
              : img
          )
        );
      } else if (context === 'item' && editItemId) {
        // Update item-level images
        setEventItemImages(prev => ({
          ...prev,
          [editItemId]: (prev[editItemId] || []).map(img =>
            toAbs(baseUrl, img.path) === oldUrl
              ? { ...img, path: newUrl.replace(baseUrl, '') }
              : img
          )
        }));
      }

      // If media was selected, update selection to new URL
      if (selectedMedia[oldUrl]) {
        setSelectedMedia(prev => {
          const updated = { ...prev };
          delete updated[oldUrl];
          updated[newUrl] = true;
          return updated;
        });
      }

      // Optionally: delete old file from server
      // Uncomment if you want to automatically delete the original after editing
      /*
      try {
        await axios.post('/api/media/delete-by-path', { 
          path: oldUrl 
        }, cfg);
        console.log('✓ Old media file deleted');
      } catch (err) {
        console.warn('Failed to delete old media file:', err);
      }
      */
    } catch (err) {
      console.error('Error updating media after edit:', err);
    } finally {
      setEditingMedia(null);
    }
  };

  // Delete confirmation modal state
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  
  const cfg = sessionRequestConfig();

  // Media editor state
  const [editingMedia, setEditingMedia] = useState(null); // { url: string, context: 'event' | 'item', itemId?: number }

  /* ---- load my role (with session headers) ---- */
  useEffect(() => {
    let alive = true;
    const cfg = sessionRequestConfig();
    axios.get(`/api/collab/events/${eventId}/my-role`, cfg)
      .then(({ data }) => { if (alive) setCollabRole(data?.role || null); })
      .catch(() => { if (alive) setCollabRole(null); });
    return () => { alive = false; };
  }, [eventId]);

  /* ---- Fetch tenant timezone ---- */
  useEffect(() => {
    const fetchTenantTimezone = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/api/tenants/${tenant}/timezone`,
          { withCredentials: true }
        );
        if (response.data.timezone) {
          setTenantTimezone(response.data.timezone);
        }
      } catch (err) {
        console.error('Failed to fetch tenant timezone:', err);
        const browserTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
        setTenantTimezone(browserTZ);
      }
    };
    
    fetchTenantTimezone();
  }, [tenant, baseUrl]);

  /* ---- load event + media + items ---- */
  useEffect(() => {
    document.body.classList.add("eventlist-fullbleed");
    return () => document.body.classList.remove("eventlist-fullbleed");
  }, []);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setLoading(true);

        // event
        const { data: eData } = await fetchFirst([
          () => axios.get(`/api/events/${tenant}/events/${eventId}`, cfg),
          () => axios.get(`/api/events/${tenant}/${eventId}`, cfg),
          () => axios.get(`/api/${tenant}/events/${eventId}`, cfg),
        ]);
        if (!alive) return;
        const e = eData?.event || eData || {};
        setEvent(e);

        // Populate form fields from loaded event
        setName(e.name || '');
        setDescription(e.description || '');
        setType(e.type || '');
        
        // Parse dates and times
        if (e.startdate) {
          const startDT = new Date(e.startdate);
          setStartDate(startDT.toISOString().split('T')[0]);
          setStartTime(startDT.toTimeString().slice(0, 5)); // HH:MM
        }
        if (e.enddate) {
          const endDT = new Date(e.enddate);
          setEndDate(endDT.toISOString().split('T')[0]);
          setEndTime(endDT.toTimeString().slice(0, 5)); // HH:MM
        }

        // event images
        const { data: imgData } = await fetchFirst([
          () => axios.get(`/api/events/${tenant}/events/${eventId}/images`, cfg),
          () => axios.get(`/api/events/${tenant}/${eventId}/images`, cfg),
          () => axios.get(`/api/${tenant}/${eventId}/images`, cfg),
        ]);
        if (!alive) return;
        setEventImages(imgData?.images || []);

        // items
        const { data: itemsData } = await fetchFirst([
          () => axios.get(`/api/events/${tenant}/events/${eventId}/items`, cfg),
          () => axios.get(`/api/events/${tenant}/${eventId}/items`, cfg),
          () => axios.get(`/api/${tenant}/${eventId}/items`, cfg),
        ]);
        if (!alive) return;
        const items = itemsData?.items || [];
        setEventItems(items);

        const itemImagesMap = {};
        const itemVideosMap = {};
        await Promise.all(
          items.map(async (it) => {
            // images
            try {
              const { data } = await fetchFirst([
                () => axios.get(`/api/events/${tenant}/events/${eventId}/items/${it.id}/images`, cfg),
                () => axios.get(`/api/events/${tenant}/${eventId}/items/${it.id}/images`, cfg),
                () => axios.get(`/api/${tenant}/${eventId}/items/${it.id}/images`, cfg),
              ]);
              itemImagesMap[it.id] = data?.images || [];
            } catch { itemImagesMap[it.id] = []; }
      
            // videos
            try {
              const { data } = await fetchFirst([
                () => axios.get(`/api/${tenant}/events/${eventId}/items/${it.id}/videos`, cfg),
                () => axios.get(`/api/events/${tenant}/events/${eventId}/items/${it.id}/videos`, cfg),
                () => axios.get(`/api/events/${tenant}/${eventId}/items/${it.id}/videos`, cfg),
              ]);
              itemVideosMap[it.id] = data?.videos || [];
            } catch { itemVideosMap[it.id] = []; }
          })
        );
        if (!alive) return;
        setEventItemImages(itemImagesMap);
        setEventItemVideos(itemVideosMap);
      } catch (err) {
        console.error("Error loading event data:", err);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [tenant, eventId]);

  /* ---- load messages ---- */
  useEffect(() => {
    axios
      .get(`${baseUrl}/api/events/${tenant}/events/${eventId}/messages`)
      .then((res) => setMessages(Array.isArray(res.data) ? res.data : res.data?.messages || res.data || []))
      .catch(() => setMessages([]));
  }, [tenant, eventId, baseUrl]);

  /* ---- helpers ---- */
  const handleShare = async () => {
    const eventUrl = `${window.location.origin}/${tenant}/${eventId}`;
    try {
      await share({ url: eventUrl, title: event?.name || "Event" });
    } catch (err) {
      console.error("Share error:", err);
      navigator.clipboard?.writeText?.(eventUrl).then(() => {
        alert("Event link copied to clipboard!");
      });
    }
  };

  const sendMessage = async () => {
    if (!newMessage.trim()) return;
    try {
      const response = await axios.post(`${baseUrl}/api/events/${tenant}/events/${eventId}/messages`, {
        message: newMessage,
      });
      if (response.data.success) {
        setMessages([...messages, { message: newMessage }]);
        setNewMessage("");
      }
    } catch (err) {
      console.error("Error sending message:", err);
    }
  };

  const updateEvent = async (e) => {
    e?.preventDefault?.();
    if (!name || !description) {
      setRegisterStatus("Name and Description are required.");
      return;
    }
    try {
      // Convert to UTC before sending
      const startDateTimeUTC = localToUTC(startDate, startTime, tenantTimezone);
      const endDateTimeUTC = localToUTC(endDate, endTime, tenantTimezone);

      const response = await axios.put(
        `${baseUrl}/api/events/${tenant}/events/${eventId}`,
        {
          name,
          description,
          type,
          startdate: startDateTimeUTC,
          enddate: endDateTimeUTC,
          timezone: tenantTimezone,
        }
      );
      if (response.data.success) {
        setRegisterStatus("Event updated successfully!");
      } else {
        setRegisterStatus("Failed to update event.");
      }
    } catch (error) {
      console.error("Error updating event:", error);
      setRegisterStatus("Error updating event.");
    }
  };

  const handleCancel = () => navigate(`/${tenant}/event`);
  const handleItem = () => navigate(`/${tenant}/${eventId}/eventItemAdd`);
  // const handleTask = () => navigate(`/${tenant}/${eventId}/taskAdd`);
  const handleTask = () => navigate(`/${tenant}/${eventId}/task`);

  /**
   * Handle posting selected media
   */
  const handlePostSelected = () => {
    const selectedUrls = Object.keys(selectedMedia).filter((url) => selectedMedia[url]);
    
    if (selectedUrls.length === 0) {
      alert("Please select at least one media item to post.");
      return;
    }

    const toPublic = (p) => (p?.startsWith("/public/") ? p : p?.startsWith("/tenants/") ? `/public${p}` : p);

    const selectedImages = [];
    const selectedVideos = [];

    // Check event-level media
    eventImages.forEach((img) => {
      const url = toAbs(baseUrl, img.path || img.url || img);
      if (selectedUrls.includes(url)) {
        selectedImages.push(toPublic(img.path || img.url || img));
      }
    });

    eventVideos.forEach((vid) => {
      const url = toAbs(baseUrl, vid.path || vid.url || vid);
      if (selectedUrls.includes(url)) {
        selectedVideos.push(toPublic(vid.path || vid.url || vid));
      }
    });

    // Check item-level media
    Object.keys(eventItemImages).forEach((itemId) => {
      eventItemImages[itemId].forEach((img) => {
        const url = toAbs(baseUrl, img.path || img.url || img);
        if (selectedUrls.includes(url)) {
          selectedImages.push(toPublic(img.path || img.url || img));
        }
      });
    });

    Object.keys(eventItemVideos).forEach((itemId) => {
      eventItemVideos[itemId].forEach((vid) => {
        const url = toAbs(baseUrl, vid.path || vid.url || vid);
        if (selectedUrls.includes(url)) {
          selectedVideos.push(toPublic(vid.path || vid.url || vid));
        }
      });
    });

    const cover = selectedImages[0] || "";

    navigate(`/${tenant}/${eventId}/mediaPost`, {
      state: {
        context: "event",
        tenant,
        eventId,
        title: name || "",
        description: description || "",
        image: cover,
        images: selectedImages,
        videos: selectedVideos,
        event,
      },
      replace: false,
    });
  };

  /**
   * Handle deleting selected media - Shows confirmation modal
   */
  const handleDeleteSelected = () => {
    const selectedUrls = Object.keys(selectedMedia).filter((url) => selectedMedia[url]);
    
    if (selectedUrls.length === 0) {
      alert("Please select at least one media item to delete.");
      return;
    }

    // Show confirmation modal instead of window.confirm
    setShowDeleteModal(true);
  };

  /**
   * Perform the actual deletion after confirmation
   */
  const performDelete = async () => {
    const selectedUrls = Object.keys(selectedMedia).filter((url) => selectedMedia[url]);

    try{
      const eventMediaUrls = [];
      const itemMediaUrls = {};

      // Check event-level media
      eventImages.forEach((img) => {
        const url = toAbs(baseUrl, img.path || img.url || img);
        if (selectedUrls.includes(url)) {
          eventMediaUrls.push(url);
        }
      });

      eventVideos.forEach((vid) => {
        const url = toAbs(baseUrl, vid.path || vid.url || vid);
        if (selectedUrls.includes(url)) {
          eventMediaUrls.push(url);
        }
      });

      // Check item-level media
      Object.keys(eventItemImages).forEach((itemId) => {
        eventItemImages[itemId].forEach((img) => {
          const url = toAbs(baseUrl, img.path || img.url || img);
          if (selectedUrls.includes(url)) {
            if (!itemMediaUrls[itemId]) itemMediaUrls[itemId] = [];
            itemMediaUrls[itemId].push(url);
          }
        });
      });

      Object.keys(eventItemVideos).forEach((itemId) => {
        eventItemVideos[itemId].forEach((vid) => {
          const url = toAbs(baseUrl, vid.path || vid.url || vid);
          if (selectedUrls.includes(url)) {
            if (!itemMediaUrls[itemId]) itemMediaUrls[itemId] = [];
            itemMediaUrls[itemId].push(url);
          }
        });
      });

      // Call backend API for event-level media
      if (eventMediaUrls.length > 0) {
        const response = await axios.delete(
          `${baseUrl}/api/events/${tenant}/events/${eventId}/media`,
          { data: { urls: eventMediaUrls } }
        );
        
        if (!response.data.success) {
          throw new Error(response.data.message || 'Failed to delete event media');
        }
      }

      // Call backend API for item-level media
      for (const itemId of Object.keys(itemMediaUrls)) {
        const response = await axios.delete(
          `${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}/media`,
          { data: { urls: itemMediaUrls[itemId] } }
        );
        
        if (!response.data.success) {
          throw new Error(response.data.message || `Failed to delete media for item ${itemId}`);
        }
      }

      // Update UI state after successful deletion
      setEventImages((prev) => 
        (prev || []).filter((x) => !selectedUrls.includes(toAbs(baseUrl, x.path || x.url || x)))
      );
      setEventVideos((prev) => 
        (prev || []).filter((x) => !selectedUrls.includes(toAbs(baseUrl, x.path || x.url || x)))
      );

      setEventItemImages((prev) => {
        const next = { ...prev };
        Object.keys(next).forEach((itemId) => {
          next[itemId] = (next[itemId] || []).filter(
            (x) => !selectedUrls.includes(toAbs(baseUrl, x.path || x.url || x))
          );
        });
        return next;
      });

      setEventItemVideos((prev) => {
        const next = { ...prev };
        Object.keys(next).forEach((itemId) => {
          next[itemId] = (next[itemId] || []).filter(
            (x) => !selectedUrls.includes(toAbs(baseUrl, x.path || x.url || x))
          );
        });
        return next;
      });

      // Clear selection
      setSelectedMedia({});

    } catch (error) {
      console.error("Error deleting selected media:", error);
      alert(`Failed to delete media: ${error.message || 'Unknown error'}. Please try again.`);
    }
  };

  /**
   * Handle deleting a single event-level media item
   */
  const handleDelete = async (url) => {
    if (!window.confirm("Delete this media?")) return;
    
    try {
      const response = await axios.delete(
        `${baseUrl}/api/events/${tenant}/events/${eventId}/media/single`,
        { data: { url } }
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to delete media');
      }

      setEventImages((prev) => (prev || []).filter((x) => toAbs(baseUrl, x.path || x.url || x) !== url));
      setEventVideos((prev) => (prev || []).filter((x) => toAbs(baseUrl, x.path || x.url || x) !== url));
      setSelectedMedia((prev) => { const n = { ...prev }; delete n[url]; return n; });

    } catch (error) {
      console.error("Error deleting media:", error);
      alert(`Failed to delete media: ${error.message || 'Unknown error'}. Please try again.`);
    }
  };

  /**
   * Handle deleting a single item-level media item
   */
  const handleDeleteItemMedia = async (itemId, url) => {
    if (!window.confirm("Delete this item media?")) return;
    
    try {
      const response = await axios.delete(
        `${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}/media/single`,
        { data: { url } }
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to delete item media');
      }

      setEventItemImages((prev) => {
        const next = { ...prev };
        next[itemId] = (next[itemId] || []).filter((x) => toAbs(baseUrl, x.path || x.url || x) !== url);
        return next;
      });
      setEventItemVideos((prev) => {
        const next = { ...prev };
        next[itemId] = (next[itemId] || []).filter((x) => toAbs(baseUrl, x.path || x.url || x) !== url);
        return next;
      });
      setSelectedMedia((prev) => { const n = { ...prev }; delete n[url]; return n; });

    } catch (error) {
      console.error("Error deleting item media:", error);
      alert(`Failed to delete item media: ${error.message || 'Unknown error'}. Please try again.`);
    }
  };

  if (loading) return <p>Loading event details...</p>;

  /* ---- merged gallery for the event ---- */
  const imgSrcs = (eventImages?.length ? eventImages : (event?.files || []))
    .filter((f) => isImage?.(f) ?? /\.(png|jpe?g|gif|webp|svg)$/i.test(f?.path || f || ""))
    .map((i) => ({ url: toAbs(baseUrl, i.path || i.url || i), isVideo: false }));
  const vidSrcs = (eventVideos?.length ? eventVideos : (event?.files || []))
    .filter((f) => isVideo?.(f) ?? /\.(mp4|mov|webm|ogg)$/i.test(f?.path || f || ""))
    .map((v) => ({ url: toAbs(baseUrl, v.path || v.url || v), isVideo: true }));
  const eventMedia = [...imgSrcs, ...vidSrcs];

  // Count selected media
  const selectedCount = Object.values(selectedMedia).filter(Boolean).length;

  return (
    <div className="container">
      <h2 className="hdr hdr--primary hdr--lg">Event Details</h2>

      {/* Collaboration header */}
      <div className="flex items-center gap-2" style={{ padding: "0 12px 8px" }}>
        <span className="text-sm text-neutral-600 dark:text-neutral-300">Collaboration</span>
        {userCanEdit && (
          <button
            type="button"
            className="btn btn-sm btn-outline"
            onClick={() => setInviteOpen(true)}
            title="Invite collaborators"
          >
            <FaPlus className="inline mr-1" />
            Invite
          </button>
        )}
      </div>

      {/* CollaboratorsPanel */}
      <CollaboratorsPanel
        tenantIdForRoutes={tenant}
        eventId={eventId}
        currentUserId={me.userId}
        canManage={userCanEdit}
      />

      {!loading ? (
        <>
          {/* Selected media count indicator */}
          {selectedCount > 0 && (
            <div
              style={{
                padding: "8px 12px",
                margin: "8px 12px",
                background: "#ff6800",
                color: "white",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: "600",
              }}
            >
              {selectedCount} media item{selectedCount !== 1 ? "s" : ""} selected
            </div>
          )}

          {/* Event form fields - matching EventAdd styling */}
          <form onSubmit={updateEvent}>
            <div className="form-group">
              <label htmlFor="name">Event Name</label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter event name"
                disabled={!userCanEdit}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="description">Event Description</label>
              <textarea
                className="form-control"
                id="description"
                name="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter event description"
                rows={4}
                disabled={!userCanEdit}
              />
            </div>

            <div className="form-group">
              <label htmlFor="type">Event Type</label>
              <input
                type="text"
                className="form-control"
                id="type"
                name="type"
                value={type}
                onChange={(e) => setType(e.target.value)}
                placeholder="Enter event type"
                disabled={!userCanEdit}
              />
            </div>

            <div className="form-group">
              <label>Start Date & Time</label>
              <div className="row">
                <div className="col-md-6">
                  <input
                    type="date"
                    className="form-control"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    disabled={!userCanEdit}
                  />
                </div>
                <div className="col-md-6">
                  <TimeSelect
                    value={startTime}
                    onChange={setStartTime}
                    tenantTimezone={tenantTimezone}
                    showTimezone={true}
                    disabled={!userCanEdit}
                  />
                </div>
              </div>
              <small className="form-hint text-muted">
                ⏰ Times are in 5-minute increments only
              </small>
            </div>

            <div className="form-group">
              <label>End Date & Time</label>
              <div className="row">
                <div className="col-md-6">
                  <input
                    type="date"
                    className="form-control"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    disabled={!userCanEdit}
                  />
                </div>
                <div className="col-md-6">
                  <TimeSelect
                    value={endTime}
                    onChange={setEndTime}
                    tenantTimezone={tenantTimezone}
                    showTimezone={true}
                    disabled={!userCanEdit}
                  />
                </div>
              </div>
              <small className="form-hint text-muted">
                ⏰ Times are in 5-minute increments only
              </small>
            </div>
          </form>

          {/* Event-level media gallery */}
          <h3 style={{ padding: "12px", marginTop: 12 }}>Event Media</h3>
          {eventMedia.length ? (
            <div className="feed" style={{ padding: 0 }}>
              {eventMedia.map((m, idx) => (
                <article
                  key={`event-${idx}`}
                  className="feed-card"
                  style={{
                    padding: 0,
                    border: "1px solid rgba(0,0,0,0.15)",
                    borderRadius: 12,
                    overflow: "hidden",
                  }}
                >
                  {/* Media display */}
                  {m.isVideo ? (
                    <video
                      className="feed-media"
                      src={m.url}
                      controls
                      preload="metadata"
                      playsInline
                      {...videoFixProps}
                    />
                  ) : (
                    <img
                      className="feed-media"
                      src={m.url}
                      alt=""
                      onError={(e) => (e.currentTarget.src = toAbs(baseUrl, "/public/app/default-image.png"))}
                    />
                  )}

                  {/* Controls BELOW the media */}
                  {/* <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "8px 12px",
                      // background: "rgba(255,255,255,0.96)",
                      background: "#01057a",
                      borderTop: "1px solid rgba(0,0,0,0.08)",
                    }}
                  >
                    <label className="flex items-center gap-2 text-sm">
                      <input
                        type="checkbox"
                        checked={!!selectedMedia[m.url]}
                        onChange={() => toggleSelect(m.url)}
                        style={{ width: 16, height: 16 }}
                      />
                      Select
                    </label>
                    

                  </div> */}
                  {/* Controls BELOW the media */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "8px 12px",
                      background: "#01057a",  // Your brand blue
                      borderTop: "1px solid rgba(0,0,0,0.08)",
                    }}
                  >
                    <label className="flex items-center gap-2 text-sm" style={{ color: "#ffffff" }}>
                      <input
                        type="checkbox"
                        checked={!!selectedMedia[m.url]}
                        onChange={() => toggleSelect(m.url)}
                        style={{ width: 16, height: 16 }}
                      />
                      Select
                    </label>
                    
                    <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                      {/* EDIT BUTTON - UPDATED STYLING */}
                      {!m.isVideo && (
                        <button
                          type="button"
                          aria-label="Edit media"
                          onClick={() => handleEditMedia(m.url, 'event')}
                          style={{ 
                            background: "#3C3C3C",  // Gray as requested
                            color: "#ffffff",
                            border: "none",
                            padding: "6px 8px",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "11px",
                            fontWeight: "500",
                            minWidth: "45px",  // Quarter width, compact
                            whiteSpace: "nowrap"
                          }}
                        >
                          Edit
                        </button>
                      )}
                    </div>
                  </div>
                </article>
              ))}
            </div>
          ) : (
            <p style={{ padding: "0 12px" }}>No media available for this event.</p>
          )}

          {/* Event items section */}
          <h3 style={{ padding: "12px", marginTop: 12 }}>Event Items</h3>
          {(eventItems || []).map((item) => {
            const imgs = eventItemImages[item.id] || [];
            const vids = eventItemVideos[item.id] || [];
            const media = [
              ...imgs.filter(isImage).map((i) => ({ url: toAbs(baseUrl, i.path), isVideo: false })),
              ...vids.filter(isVideo).map((v) => ({ url: toAbs(baseUrl, v.path), isVideo: true })),
            ];
            if (!media.length) return null;

            const toDetail = `/${tenant}/${eventId}/${item.id}/eventItemDetail`;

            return (
              <section key={`item-${item.id}`} style={{ marginBottom: 12 }}>
                <Link
                  to={toDetail}
                  className="text-decoration-none"
                  style={{ display: "inline-block", margin: "0 12px 8px" }}
                >
                  <strong>{item.name || `Item #${item.id}`}</strong>
                </Link>

                <div className="feed" style={{ padding: 0 }}>
                  {media.map((m, idx) => (
                    <article
                      key={`${item.id}-${idx}`}
                      className="feed-card"
                      style={{
                        padding: 0,
                        border: "1px solid rgba(0,0,0,0.15)",
                        borderRadius: 12,
                        overflow: "hidden",
                        cursor: "pointer",
                      }}
                      onClick={() => navigate(toDetail)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && navigate(toDetail)}
                    >
                      {m.isVideo ? (
                        <video
                          className="feed-media"
                          src={m.url}
                          controls
                          preload="metadata"
                          playsInline
                          {...videoFixProps}
                        />
                      ) : (
                        <img
                          className="feed-media"
                          src={m.url}
                          alt=""
                          onError={(e) =>
                            (e.currentTarget.src = toAbs(baseUrl, "/public/app/default-image.png"))
                          }
                        />
                      )}

                      {/* <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "8px 12px",
                          background: "#01057a",
                          color: "#ffffff",
                          borderTop: "1px solid rgba(255,255,255,0.1)",
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <label className="flex items-center gap-2 text-sm" style={{ color: "#ffffff" }}>
                          <input
                            type="checkbox"
                            checked={!!selectedMedia[m.url]}
                            onChange={() => toggleSelect(m.url)}
                            style={{ width: 16, height: 16 }}
                          />
                          Select
                        </label>
                        

                      </div> */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "8px 12px",
                          background: "#01057a",  // Your brand blue
                          color: "#ffffff",
                          borderTop: "1px solid rgba(255,255,255,0.1)",
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <label className="flex items-center gap-2 text-sm" style={{ color: "#ffffff" }}>
                          <input
                            type="checkbox"
                            checked={!!selectedMedia[m.url]}
                            onChange={() => toggleSelect(m.url)}
                            style={{ width: 16, height: 16 }}
                          />
                          Select
                        </label>
                        
                        <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                          {/* EDIT BUTTON - UPDATED STYLING */}
                          {!m.isVideo && (
                            <button
                              type="button"
                              aria-label="Edit item media"
                              onClick={() => handleEditMedia(m.url, 'item', item.id)}
                              style={{ 
                                background: "#3C3C3C",  // Gray as requested
                                color: "#ffffff",
                                border: "none",
                                padding: "6px 8px",
                                borderRadius: "4px",
                                cursor: "pointer",
                                fontSize: "11px",
                                fontWeight: "500",
                                minWidth: "45px",  // Quarter width, compact
                                whiteSpace: "nowrap"
                              }}
                            >
                              Edit
                            </button>
                          )}
                        </div>
                      </div>
                    </article>
                  ))}
                </div>
              </section>
            );
          })}

          {registerStatus && <p className="mt-3" style={{ padding: "0 12px" }}>{registerStatus}</p>}
          
          {/* Comments section */}
          <CommentsPanel baseUrl={baseUrl} tenantId={tenant} eventId={eventId} />
        </>
      ) : (
        <p>Loading event details...</p>
      )}

      {/* Media Editor Modal */}
      {editingMedia && (
        <MediaEditor
          src={editingMedia.url}
          tenantId={tenant}
          eventId={eventId}
          itemId={editingMedia.itemId}
          onClose={() => setEditingMedia(null)}
          onSaved={handleMediaSaved}
          uploadUrl="/api/media/upload"
        />
      )}

      {/* Footer with dynamic buttons */}
      <AppFooter
        buttons={[
          {
            icon: <FaArrowLeft />,
            label: "Back",
            onClick: () => navigate(-1),
          },
          { 
            icon: <FaPlus />, 
            label: "Add Item", 
            onClick: () => handleItem(true) 
          },
          { 
            icon: <FaTasks />, 
            label: "Task", 
            onClick: () => handleTask(true) 
          },
          ...(selectedCount > 0 ? [{
            icon: <FaShare />,
            label: `Post (${selectedCount})`,
            onClick: () => setPostChoiceOpen(true),
          }] : [{
            icon: <FaShare />,
            label: "Post",
            onClick: () => setPostChoiceOpen(true),
          }]),
          ...(selectedCount > 0 ? [{
            icon: <FaTrash />,
            label: `Delete (${selectedCount})`,
            onClick: handleDeleteSelected,
          }] : []),
          { 
            icon: <FaSave />, 
            label: "Save", 
            onClick: updateEvent, 
            type: "submit", 
            disabled: !userCanEdit 
          },
        ]}
      />

      {/* Post choice modal */}
      {postChoiceOpen && (
        <PostChoiceModal
          isOpen={postChoiceOpen}
          onClose={() => setPostChoiceOpen(false)}
          title={selectedCount > 0 ? "Post Selected Media" : "Event Post"}
          hint={selectedCount > 0 
            ? `Post ${selectedCount} selected media item(s) now or schedule a post.` 
            : "Post now (opens your full post flow) or schedule a post."}
          onPostNow={() => { 
            setPostChoiceOpen(false); 
            if (selectedCount > 0) {
              handlePostSelected();
            } else {
              navigate(`/${tenant}/${eventId}/mediaPost`, {
                state: {
                  context: "event",
                  tenant,
                  eventId,
                  title: name || "",
                  description: description || "",
                  event,
                },
              });
            }
          }}
          onSchedule={() => {
            setPostChoiceOpen(false);
            
            if (selectedCount > 0) {
              const selectedUrls = Object.keys(selectedMedia).filter((url) => selectedMedia[url]);
              const toPublic = (p) => (p?.startsWith("/public/") ? p : p?.startsWith("/tenants/") ? `/public${p}` : p);
              
              const selectedImages = [];
              const selectedVideos = [];

              eventImages.forEach((img) => {
                const url = toAbs(baseUrl, img.path || img.url || img);
                if (selectedUrls.includes(url)) {
                  selectedImages.push(toPublic(img.path || img.url || img));
                }
              });

              eventVideos.forEach((vid) => {
                const url = toAbs(baseUrl, vid.path || vid.url || vid);
                if (selectedUrls.includes(url)) {
                  selectedVideos.push(toPublic(vid.path || vid.url || vid));
                }
              });

              Object.keys(eventItemImages).forEach((itemId) => {
                eventItemImages[itemId].forEach((img) => {
                  const url = toAbs(baseUrl, img.path || img.url || img);
                  if (selectedUrls.includes(url)) {
                    selectedImages.push(toPublic(img.path || img.url || img));
                  }
                });
              });

              Object.keys(eventItemVideos).forEach((itemId) => {
                eventItemVideos[itemId].forEach((vid) => {
                  const url = toAbs(baseUrl, vid.path || vid.url || vid);
                  if (selectedUrls.includes(url)) {
                    selectedVideos.push(toPublic(vid.path || vid.url || vid));
                  }
                });
              });

              navigate(`/${tenant}/${eventId}/schedulePost`, {
                state: {
                  context: "event",
                  tenant,
                  eventId,
                  title: name || "",
                  description: description || "",
                  image: selectedImages[0] || "",
                  images: selectedImages,
                  videos: selectedVideos,
                  event,
                },
              });
            } else {
              navigate(`/${tenant}/${eventId}/schedulePost`);
            }
          }}
        />
      )}

      {/* Confirm Delete Modal */}
      <ConfirmDeleteModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={performDelete}
        count={Object.values(selectedMedia).filter(Boolean).length}
        context="event"
      />

      {/* Invite Collaborator Modal */}
      <InviteCollaboratorModal
        tenantIdForRoutes={tenant}
        eventId={eventId}
        open={inviteOpen}
        onClose={() => setInviteOpen(false)}
        onInvited={() => {}}
      />
    </div>
  );
};

export default EventDetail;